const DIALECT = {
  Dashboard: {
    en: 'Dashboard',
    fr: 'Tableau de bord',
    ar: 'لوحة القيادة'
  },
  'Control stock health, inventory value movement, and team activity from one place.':
    {
      en: 'Control stock health, inventory value movement, and team activity from one place.',
      fr: "Contrôlez l'état du stock, l'évolution de la valeur de l'inventaire et l'activité de l'équipe depuis un seul endroit.",
      ar: 'تحكم في صحة المخزون وحركة قيمة المخزون ونشاط الفريق من مكان واحد.'
    },
  'Inventory Value Movement': {
    en: 'Inventory Value Movement',
    fr: "Évolution de la valeur de l'inventaire",
    ar: 'حركة قيمة المخزون'
  },
  'Track value added to inventory versus value removed over time.': {
    en: 'Track value added to inventory versus value removed over time.',
    fr: "Suivez la valeur ajoutée à l'inventaire par rapport à la valeur retirée au fil du temps.",
    ar: 'تتبع القيمة المضافة إلى المخزون مقابل القيمة المزالة بمرور الوقت.'
  },
  'Restock Risks': {
    en: 'Restock Risks',
    fr: 'Risques de réapprovisionnement',
    ar: 'مخاطر إعادة التزويد'
  },
  'Items that need attention before they slow down your operations.': {
    en: 'Items that need attention before they slow down your operations.',
    fr: 'Articles qui nécessitent une attention avant de ralentir vos opérations.',
    ar: 'العناصر التي تحتاج إلى انتباه قبل أن تبطئ عملياتك.'
  },
  'Activity & Audit Trail': {
    en: 'Activity & Audit Trail',
    fr: "Activité et journal d'audit",
    ar: 'النشاط وسجل التدقيق'
  },
  'Top Risks': {
    en: 'Top Risks',
    fr: 'Principaux risques',
    ar: 'أهم المخاطر'
  },
  'The most important things to fix first.': {
    en: 'The most important things to fix first.',
    fr: 'Les éléments les plus importants à corriger en premier.',
    ar: 'أهم الأمور التي يجب إصلاحها أولاً.'
  },
  'No major risks detected': {
    en: 'No major risks detected',
    fr: 'Aucun risque majeur détecté',
    ar: 'لم يتم اكتشاف مخاطر كبيرة'
  },
  'Your dashboard will highlight urgent stock issues here.': {
    en: 'Your dashboard will highlight urgent stock issues here.',
    fr: 'Votre tableau de bord affichera ici les problèmes de stock urgents.',
    ar: 'ستعرض لوحة المعلومات مشاكل المخزون العاجلة هنا.'
  },
  Current: {
    en: 'Current',
    fr: 'Actuel',
    ar: 'الحالي'
  },
  Minimum: {
    en: 'Minimum',
    fr: 'Minimum',
    ar: 'الحد الأدنى'
  },
  Missing: {
    en: 'Missing',
    fr: 'Manquant',
    ar: 'الناقص'
  },
  'items are out of stock': {
    en: 'items are out of stock',
    fr: 'articles sont en rupture de stock',
    ar: 'عناصر غير متوفرة في المخزون'
  },
  'items need restocking': {
    en: 'items need restocking',
    fr: 'articles doivent être réapprovisionnés',
    ar: 'عناصر تحتاج إلى إعادة التزويد'
  },
  'These items can block sales or operations.': {
    en: 'These items can block sales or operations.',
    fr: 'Ces articles peuvent bloquer les ventes ou les opérations.',
    ar: 'يمكن لهذه العناصر أن تعطل المبيعات أو العمليات.'
  },
  'Review minimum levels and prepare replenishment.': {
    en: 'Review minimum levels and prepare replenishment.',
    fr: 'Vérifiez les niveaux minimums et préparez le réapprovisionnement.',
    ar: 'راجع الحدود الدنيا وجهز إعادة التزويد.'
  },
  'Stock out value is higher than stock in value': {
    en: 'Stock out value is higher than stock in value',
    fr: 'La valeur du stock sortant est supérieure à celle du stock entrant',
    ar: 'قيمة المخزون الخارج أعلى من قيمة المخزون الداخل'
  },
  'Net movement': {
    en: 'Net movement',
    fr: 'Mouvement net',
    ar: 'صافي الحركة'
  },
  'View audit log': {
    en: 'View audit log',
    fr: "Voir le journal d'audit",
    ar: 'عرض سجل التدقيق'
  },
  Jan: {
    en: 'Jan',
    fr: 'Janv.',
    ar: 'يناير'
  },
  Feb: {
    en: 'Feb',
    fr: 'Févr.',
    ar: 'فبراير'
  },
  Mar: {
    en: 'Mar',
    fr: 'Mars',
    ar: 'مارس'
  },
  Apr: {
    en: 'Apr',
    fr: 'Avr.',
    ar: 'أبريل'
  },
  May: {
    en: 'May',
    fr: 'Mai',
    ar: 'مايو'
  },
  Jun: {
    en: 'Jun',
    fr: 'Juin',
    ar: 'يونيو'
  },
  Jul: {
    en: 'Jul',
    fr: 'Juil.',
    ar: 'يوليو'
  },
  Aug: {
    en: 'Aug',
    fr: 'Août',
    ar: 'أغسطس'
  },
  Sep: {
    en: 'Sep',
    fr: 'Sept.',
    ar: 'سبتمبر'
  },
  Oct: {
    en: 'Oct',
    fr: 'Oct.',
    ar: 'أكتوبر'
  },
  Nov: {
    en: 'Nov',
    fr: 'Nov.',
    ar: 'نوفمبر'
  },
  Dec: {
    en: 'Dec',
    fr: 'Déc.',
    ar: 'ديسمبر'
  },
  'a.m.': {
    en: 'a.m.',
    fr: 'a. m.',
    ar: 'ص'
  },
  'p.m.': {
    en: 'p.m.',
    fr: 'p. m.',
    ar: 'م'
  },
  Inventory: {
    en: 'Inventory',
    fr: 'Inventaire',
    ar: 'المخزون'
  },
  Analytics: {
    en: 'Analytics',
    fr: 'Analytique',
    ar: 'التحليلات'
  },
  'Smart Inventory Management': {
    en: 'Smart Inventory Management',
    fr: 'Gestion intelligente des stocks',
    ar: 'إدارة المخزون الذكي'
  },
  Items: {
    en: 'Items',
    fr: 'Articles',
    ar: 'العناصر'
  },
  'Low Stock': {
    en: 'Low Stock',
    fr: 'Stock faible',
    ar: 'المخزون المنخفض'
  },
  'Overview of your inventory system': {
    en: 'Overview of your inventory system',
    fr: "Aperçu de votre système d'inventaire",
    ar: 'نظرة عامة على نظام المخزون الخاص بك'
  },
  'Search folders or categories': {
    en: 'Search folders or categories',
    fr: 'Rechercher des dossiers ou des catégories',
    ar: 'البحث في المجلدات أو الفئات'
  },
  'Select from list or type a new reason': {
    en: 'Select from list or type a new reason',
    fr: 'Sélectionnez dans la liste ou tapez une nouvelle raison',
    ar: 'اختر من القائمة أو اكتب سببًا جديدًا'
  },
  Explorer: {
    en: 'Explorer',
    fr: 'Explorateur',
    ar: 'المستكشف'
  },
  Folders: {
    en: 'Folders',
    fr: 'Dossiers',
    ar: 'المجلدات'
  },
  Reports: {
    en: 'Reports',
    fr: 'Rapports',
    ar: 'تقارير'
  },
  'Search All Items': {
    en: 'Search All Items',
    fr: 'Rechercher tous les articles',
    ar: 'البحث في جميع العناصر'
  },
  'Search by name': {
    en: 'Search by name',
    fr: 'Rechercher par nom',
    ar: 'البحث بالاسم'
  },
  Search: {
    en: 'Search',
    fr: 'Chercher',
    ar: 'بحث'
  },
  Tags: {
    en: 'Tags',
    fr: 'Mots clés',
    ar: 'الكلمات'
  },
  Finances: {
    en: 'Finances',
    fr: 'Finances',
    ar: 'المالية'
  },
  Tips: {
    en: 'Tips',
    fr: 'Conseils',
    ar: 'نصائح'
  },
  Alerts: {
    en: 'Alerts',
    fr: 'Alertes',
    ar: 'تنبيهات'
  },
  Settings: {
    en: 'Settings',
    fr: 'Paramètres',
    ar: 'الإعدادات'
  },
  'Configure how Ventlly displays currency, timezone, and your current plan.': {
    en: 'Configure how Ventlly displays currency, timezone, and your current plan.',
    fr: 'Configurez la façon dont Ventlly affiche la devise, le fuseau horaire et votre forfait actuel.',
    ar: 'اضبط طريقة عرض Ventlly للعملة والمنطقة الزمنية وخطتك الحالية.'
  },
  'Loading organization settings...': {
    en: 'Loading organization settings...',
    fr: "Chargement des paramètres de l'organisation...",
    ar: 'جارٍ تحميل إعدادات المؤسسة...'
  },
  'Failed to load settings. Default values are shown.': {
    en: 'Failed to load settings. Default values are shown.',
    fr: 'Impossible de charger les paramètres. Les valeurs par défaut sont affichées.',
    ar: 'تعذر تحميل الإعدادات. يتم عرض القيم الافتراضية.'
  },
  'General preferences': {
    en: 'General preferences',
    fr: 'Préférences générales',
    ar: 'التفضيلات العامة'
  },
  Currency: {
    en: 'Currency',
    fr: 'Devise',
    ar: 'العملة'
  },
  'Used for item values, reports, invoices, purchase orders, and dashboards.': {
    en: 'Used for item values, reports, invoices, purchase orders, and dashboards.',
    fr: "Utilisée pour les valeurs d'articles, les rapports, les factures, les bons de commande et les tableaux de bord.",
    ar: 'تُستخدم لقيم العناصر والتقارير والفواتير وأوامر الشراء ولوحات المعلومات.'
  },
  'Default currency': {
    en: 'Default currency',
    fr: 'Devise par défaut',
    ar: 'العملة الافتراضية'
  },
  Timezone: {
    en: 'Timezone',
    fr: 'Fuseau horaire',
    ar: 'المنطقة الزمنية'
  },
  'Used for reports, movements, invoices, audit logs, and dashboard dates.': {
    en: 'Used for reports, movements, invoices, audit logs, and dashboard dates.',
    fr: "Utilisé pour les rapports, les mouvements, les factures, les journaux d'audit et les dates du tableau de bord.",
    ar: 'تُستخدم للتقارير والحركات والفواتير وسجلات التدقيق وتواريخ لوحة المعلومات.'
  },
  'Default timezone': {
    en: 'Default timezone',
    fr: 'Fuseau horaire par défaut',
    ar: 'المنطقة الزمنية الافتراضية'
  },
  Plan: {
    en: 'Plan',
    fr: 'Forfait',
    ar: 'الخطة'
  },
  'Current organization plan. For now, this can be managed here. Later, Stripe should control it.':
    {
      en: 'Current organization plan. For now, this can be managed here. Later, Stripe should control it.',
      fr: "Forfait actuel de l'organisation. Pour l'instant, il peut être géré ici. Plus tard, Stripe devrait le contrôler.",
      ar: 'الخطة الحالية للمؤسسة. حالياً يمكن إدارتها هنا. لاحقاً يجب أن يتحكم بها Stripe.'
    },
  'Current plan': {
    en: 'Current plan',
    fr: 'Forfait actuel',
    ar: 'الخطة الحالية'
  },
  Reset: {
    en: 'Reset',
    fr: 'Réinitialiser',
    ar: 'إعادة تعيين'
  },
  'Save settings': {
    en: 'Save settings',
    fr: 'Enregistrer les paramètres',
    ar: 'حفظ الإعدادات'
  },
  'Current setup': {
    en: 'Current setup',
    fr: 'Configuration actuelle',
    ar: 'الإعداد الحالي'
  },
  'These settings affect how data is displayed across Ventlly. Existing items will not be deleted or modified.':
    {
      en: 'These settings affect how data is displayed across Ventlly. Existing items will not be deleted or modified.',
      fr: "Ces paramètres affectent l'affichage des données dans Ventlly. Les articles existants ne seront ni supprimés ni modifiés.",
      ar: 'تؤثر هذه الإعدادات على طريقة عرض البيانات في Ventlly. لن يتم حذف العناصر الحالية أو تعديلها.'
    },
  'Good to know': {
    en: 'Good to know',
    fr: 'Bon à savoir',
    ar: 'من الجيد معرفة ذلك'
  },
  'Currency affects reports and financial values.': {
    en: 'Currency affects reports and financial values.',
    fr: 'La devise affecte les rapports et les valeurs financières.',
    ar: 'تؤثر العملة على التقارير والقيم المالية.'
  },
  'Timezone affects dates shown in movements and dashboards.': {
    en: 'Timezone affects dates shown in movements and dashboards.',
    fr: 'Le fuseau horaire affecte les dates affichées dans les mouvements et les tableaux de bord.',
    ar: 'تؤثر المنطقة الزمنية على التواريخ المعروضة في الحركات ولوحات المعلومات.'
  },
  'Plan should later be managed by Stripe/subscription status.': {
    en: 'Plan should later be managed by Stripe/subscription status.',
    fr: "Le forfait devrait plus tard être géré par Stripe ou l'état de l'abonnement.",
    ar: 'يجب أن تتم إدارة الخطة لاحقاً من خلال Stripe أو حالة الاشتراك.'
  },
  'Failed to load settings': {
    en: 'Failed to load settings',
    fr: 'Impossible de charger les paramètres',
    ar: 'تعذر تحميل الإعدادات'
  },
  'Changes reset': {
    en: 'Changes reset',
    fr: 'Modifications réinitialisées',
    ar: 'تمت إعادة تعيين التغييرات'
  },
  'Settings saved successfully': {
    en: 'Settings saved successfully',
    fr: 'Paramètres enregistrés avec succès',
    ar: 'تم حفظ الإعدادات بنجاح'
  },
  'Failed to save settings. Please try again.': {
    en: 'Failed to save settings. Please try again.',
    fr: "Impossible d'enregistrer les paramètres. Veuillez réessayer.",
    ar: 'تعذر حفظ الإعدادات. يرجى المحاولة مرة أخرى.'
  },
  'US Dollar': {
    en: 'US Dollar',
    fr: 'Dollar américain',
    ar: 'الدولار الأمريكي'
  },
  Euro: {
    en: 'Euro',
    fr: 'Euro',
    ar: 'اليورو'
  },
  'British Pound': {
    en: 'British Pound',
    fr: 'Livre sterling',
    ar: 'الجنيه الإسترليني'
  },
  'Moroccan Dirham': {
    en: 'Moroccan Dirham',
    fr: 'Dirham marocain',
    ar: 'الدرهم المغربي'
  },
  'Canadian Dollar': {
    en: 'Canadian Dollar',
    fr: 'Dollar canadien',
    ar: 'الدولار الكندي'
  },
  'Australian Dollar': {
    en: 'Australian Dollar',
    fr: 'Dollar australien',
    ar: 'الدولار الأسترالي'
  },
  'Japanese Yen': {
    en: 'Japanese Yen',
    fr: 'Yen japonais',
    ar: 'الين الياباني'
  },
  'Indian Rupee': {
    en: 'Indian Rupee',
    fr: 'Roupie indienne',
    ar: 'الروبية الهندية'
  },
  Free: {
    en: 'Free',
    fr: 'Gratuit',
    ar: 'مجانية'
  },
  Starter: {
    en: 'Starter',
    fr: 'Démarrage',
    ar: 'البداية'
  },
  Pro: {
    en: 'Pro',
    fr: 'Pro',
    ar: 'احترافية'
  },
  Business: {
    en: 'Business',
    fr: 'Entreprise',
    ar: 'الأعمال'
  },
  Advanced: {
    en: 'Advanced',
    fr: 'Avancé',
    ar: 'متقدمة'
  },
  Premium: {
    en: 'Premium',
    fr: 'Premium',
    ar: 'مميزة'
  },
  'Basic plan for testing Ventlly.': {
    en: 'Basic plan for testing Ventlly.',
    fr: 'Forfait de base pour tester Ventlly.',
    ar: 'خطة أساسية لاختبار Ventlly.'
  },
  'Good for small businesses starting with inventory tracking.': {
    en: 'Good for small businesses starting with inventory tracking.',
    fr: 'Adapté aux petites entreprises qui commencent le suivi des stocks.',
    ar: 'مناسبة للشركات الصغيرة التي تبدأ بتتبع المخزون.'
  },
  'For growing teams that need stronger reports and workflows.': {
    en: 'For growing teams that need stronger reports and workflows.',
    fr: 'Pour les équipes en croissance qui ont besoin de rapports et de flux de travail plus solides.',
    ar: 'للفرق النامية التي تحتاج إلى تقارير وسير عمل أقوى.'
  },
  'For companies managing multiple users and operations.': {
    en: 'For companies managing multiple users and operations.',
    fr: 'Pour les entreprises qui gèrent plusieurs utilisateurs et opérations.',
    ar: 'للشركات التي تدير عدة مستخدمين وعمليات.'
  },
  'For businesses needing advanced permissions and automation.': {
    en: 'For businesses needing advanced permissions and automation.',
    fr: "Pour les entreprises qui ont besoin d'autorisations avancées et d'automatisation.",
    ar: 'للشركات التي تحتاج إلى أذونات متقدمة وأتمتة.'
  },
  'For larger teams with priority features and support.': {
    en: 'For larger teams with priority features and support.',
    fr: 'Pour les grandes équipes avec des fonctionnalités et une assistance prioritaires.',
    ar: 'للفرق الأكبر التي تحتاج إلى ميزات ودعم ذي أولوية.'
  },
  'GMT-12:00 — Baker Island': {
    en: 'GMT-12:00 — Baker Island',
    fr: 'GMT-12:00 — Île Baker',
    ar: 'GMT-12:00 — جزيرة بيكر'
  },
  'UTC-12': {
    en: 'UTC-12',
    fr: 'UTC-12',
    ar: 'UTC-12'
  },
  'GMT-11:00 — Pago Pago': {
    en: 'GMT-11:00 — Pago Pago',
    fr: 'GMT-11:00 — Pago Pago',
    ar: 'GMT-11:00 — باغو باغو'
  },
  'American Samoa': {
    en: 'American Samoa',
    fr: 'Samoa américaines',
    ar: 'ساموا الأمريكية'
  },
  'GMT-10:00 — Honolulu': {
    en: 'GMT-10:00 — Honolulu',
    fr: 'GMT-10:00 — Honolulu',
    ar: 'GMT-10:00 — هونولولو'
  },
  Hawaii: {
    en: 'Hawaii',
    fr: 'Hawaï',
    ar: 'هاواي'
  },
  'GMT-09:00 — Anchorage': {
    en: 'GMT-09:00 — Anchorage',
    fr: 'GMT-09:00 — Anchorage',
    ar: 'GMT-09:00 — أنكوريج'
  },
  Alaska: {
    en: 'Alaska',
    fr: 'Alaska',
    ar: 'ألاسكا'
  },
  'GMT-08:00 — Los Angeles / Vancouver': {
    en: 'GMT-08:00 — Los Angeles / Vancouver',
    fr: 'GMT-08:00 — Los Angeles / Vancouver',
    ar: 'GMT-08:00 — لوس أنجلوس / فانكوفر'
  },
  'Pacific Time': {
    en: 'Pacific Time',
    fr: 'Heure du Pacifique',
    ar: 'توقيت المحيط الهادئ'
  },
  'GMT-07:00 — Denver / Calgary': {
    en: 'GMT-07:00 — Denver / Calgary',
    fr: 'GMT-07:00 — Denver / Calgary',
    ar: 'GMT-07:00 — دنفر / كالغاري'
  },
  'Mountain Time': {
    en: 'Mountain Time',
    fr: 'Heure des Rocheuses',
    ar: 'توقيت الجبال'
  },
  'GMT-06:00 — Chicago / Mexico City': {
    en: 'GMT-06:00 — Chicago / Mexico City',
    fr: 'GMT-06:00 — Chicago / Mexico',
    ar: 'GMT-06:00 — شيكاغو / مكسيكو سيتي'
  },
  'Central Time': {
    en: 'Central Time',
    fr: 'Heure du Centre',
    ar: 'التوقيت المركزي'
  },
  'GMT-05:00 — Montreal / New York / Toronto': {
    en: 'GMT-05:00 — Montreal / New York / Toronto',
    fr: 'GMT-05:00 — Montréal / New York / Toronto',
    ar: 'GMT-05:00 — مونتريال / نيويورك / تورونتو'
  },
  'Eastern Time': {
    en: 'Eastern Time',
    fr: "Heure de l'Est",
    ar: 'التوقيت الشرقي'
  },
  'GMT-04:00 — Halifax / Caracas': {
    en: 'GMT-04:00 — Halifax / Caracas',
    fr: 'GMT-04:00 — Halifax / Caracas',
    ar: 'GMT-04:00 — هاليفاكس / كاراكاس'
  },
  'Atlantic Time': {
    en: 'Atlantic Time',
    fr: "Heure de l'Atlantique",
    ar: 'توقيت الأطلسي'
  },
  'GMT-03:00 — Buenos Aires / São Paulo': {
    en: 'GMT-03:00 — Buenos Aires / São Paulo',
    fr: 'GMT-03:00 — Buenos Aires / São Paulo',
    ar: 'GMT-03:00 — بوينس آيرس / ساو باولو'
  },
  'Argentina / Brazil region': {
    en: 'Argentina / Brazil region',
    fr: 'Région Argentine / Brésil',
    ar: 'منطقة الأرجنتين / البرازيل'
  },
  'GMT-02:00 — South Georgia': {
    en: 'GMT-02:00 — South Georgia',
    fr: 'GMT-02:00 — Géorgie du Sud',
    ar: 'GMT-02:00 — جورجيا الجنوبية'
  },
  'South Atlantic': {
    en: 'South Atlantic',
    fr: 'Atlantique Sud',
    ar: 'جنوب الأطلسي'
  },
  'GMT-01:00 — Azores': {
    en: 'GMT-01:00 — Azores',
    fr: 'GMT-01:00 — Açores',
    ar: 'GMT-01:00 — الأزور'
  },
  'Azores Islands': {
    en: 'Azores Islands',
    fr: 'Îles des Açores',
    ar: 'جزر الأزور'
  },
  'GMT+00:00 — London / Lisbon / UTC': {
    en: 'GMT+00:00 — London / Lisbon / UTC',
    fr: 'GMT+00:00 — Londres / Lisbonne / UTC',
    ar: 'GMT+00:00 — لندن / لشبونة / UTC'
  },
  'GMT+00:00 — UTC': {
    en: 'GMT+00:00 — UTC',
    fr: 'GMT+00:00 — UTC',
    ar: 'GMT+00:00 — UTC'
  },
  'Greenwich Mean Time': {
    en: 'Greenwich Mean Time',
    fr: 'Temps moyen de Greenwich',
    ar: 'توقيت غرينتش'
  },
  'GMT+01:00 — Casablanca / Paris / Madrid': {
    en: 'GMT+01:00 — Casablanca / Paris / Madrid',
    fr: 'GMT+01:00 — Casablanca / Paris / Madrid',
    ar: 'GMT+01:00 — الدار البيضاء / باريس / مدريد'
  },
  'Morocco / Central Europe': {
    en: 'Morocco / Central Europe',
    fr: 'Maroc / Europe centrale',
    ar: 'المغرب / أوروبا الوسطى'
  },
  'GMT+02:00 — Cairo / Johannesburg / Athens': {
    en: 'GMT+02:00 — Cairo / Johannesburg / Athens',
    fr: 'GMT+02:00 — Le Caire / Johannesburg / Athènes',
    ar: 'GMT+02:00 — القاهرة / جوهانسبرغ / أثينا'
  },
  'Eastern Europe / Africa': {
    en: 'Eastern Europe / Africa',
    fr: 'Europe de l’Est / Afrique',
    ar: 'أوروبا الشرقية / أفريقيا'
  },
  'GMT+03:00 — Istanbul / Riyadh / Moscow': {
    en: 'GMT+03:00 — Istanbul / Riyadh / Moscow',
    fr: 'GMT+03:00 — Istanbul / Riyad / Moscou',
    ar: 'GMT+03:00 — إسطنبول / الرياض / موسكو'
  },
  'Turkey / Arabia / Moscow region': {
    en: 'Turkey / Arabia / Moscow region',
    fr: 'Turquie / Arabie / région de Moscou',
    ar: 'تركيا / الجزيرة العربية / منطقة موسكو'
  },
  'GMT+04:00 — Dubai / Abu Dhabi': {
    en: 'GMT+04:00 — Dubai / Abu Dhabi',
    fr: 'GMT+04:00 — Dubaï / Abou Dhabi',
    ar: 'GMT+04:00 — دبي / أبوظبي'
  },
  'United Arab Emirates': {
    en: 'United Arab Emirates',
    fr: 'Émirats arabes unis',
    ar: 'الإمارات العربية المتحدة'
  },
  'GMT+05:00 — Karachi / Tashkent': {
    en: 'GMT+05:00 — Karachi / Tashkent',
    fr: 'GMT+05:00 — Karachi / Tachkent',
    ar: 'GMT+05:00 — كراتشي / طشقند'
  },
  'Pakistan / Uzbekistan': {
    en: 'Pakistan / Uzbekistan',
    fr: 'Pakistan / Ouzbékistan',
    ar: 'باكستان / أوزبكستان'
  },
  'GMT+06:00 — Dhaka / Almaty': {
    en: 'GMT+06:00 — Dhaka / Almaty',
    fr: 'GMT+06:00 — Dacca / Almaty',
    ar: 'GMT+06:00 — دكا / ألماتي'
  },
  'Bangladesh / Kazakhstan': {
    en: 'Bangladesh / Kazakhstan',
    fr: 'Bangladesh / Kazakhstan',
    ar: 'بنغلاديش / كازاخستان'
  },
  'GMT+07:00 — Bangkok / Jakarta': {
    en: 'GMT+07:00 — Bangkok / Jakarta',
    fr: 'GMT+07:00 — Bangkok / Jakarta',
    ar: 'GMT+07:00 — بانكوك / جاكرتا'
  },
  'Thailand / Indonesia': {
    en: 'Thailand / Indonesia',
    fr: 'Thaïlande / Indonésie',
    ar: 'تايلاند / إندونيسيا'
  },
  'GMT+08:00 — Singapore / Hong Kong / Beijing': {
    en: 'GMT+08:00 — Singapore / Hong Kong / Beijing',
    fr: 'GMT+08:00 — Singapour / Hong Kong / Pékin',
    ar: 'GMT+08:00 — سنغافورة / هونغ كونغ / بكين'
  },
  'East Asia business timezone': {
    en: 'East Asia business timezone',
    fr: "Fuseau horaire d'affaires d'Asie de l'Est",
    ar: 'منطقة زمنية للأعمال في شرق آسيا'
  },
  'GMT+09:00 — Tokyo / Seoul': {
    en: 'GMT+09:00 — Tokyo / Seoul',
    fr: 'GMT+09:00 — Tokyo / Séoul',
    ar: 'GMT+09:00 — طوكيو / سيول'
  },
  'Japan / South Korea': {
    en: 'Japan / South Korea',
    fr: 'Japon / Corée du Sud',
    ar: 'اليابان / كوريا الجنوبية'
  },
  'GMT+10:00 — Sydney / Melbourne': {
    en: 'GMT+10:00 — Sydney / Melbourne',
    fr: 'GMT+10:00 — Sydney / Melbourne',
    ar: 'GMT+10:00 — سيدني / ملبورن'
  },
  'Eastern Australia': {
    en: 'Eastern Australia',
    fr: 'Australie orientale',
    ar: 'شرق أستراليا'
  },
  'GMT+12:00 — Auckland / Fiji': {
    en: 'GMT+12:00 — Auckland / Fiji',
    fr: 'GMT+12:00 — Auckland / Fidji',
    ar: 'GMT+12:00 — أوكلاند / فيجي'
  },
  'New Zealand / Pacific': {
    en: 'New Zealand / Pacific',
    fr: 'Nouvelle-Zélande / Pacifique',
    ar: 'نيوزيلندا / المحيط الهادئ'
  },
  'My Categories': {
    en: 'My Categories',
    fr: 'Mes catégories',
    ar: 'تصنيفاتي'
  },
  'All Items': {
    en: 'All Items',
    fr: 'Tous les articles',
    ar: 'جميع العناصر'
  },
  'All Folders': {
    en: 'All Folders',
    fr: 'Tous les dossiers',
    ar: 'جميع المجلدات'
  },
  Transactions: {
    en: 'Transactions',
    fr: 'Transactions',
    ar: 'المعاملات'
  },
  'My Folders': {
    en: 'My Folders',
    fr: 'Mes dossiers',
    ar: 'مجلداتي'
  },
  'Available Inventories': {
    en: 'Available Inventories',
    fr: 'Inventaires disponibles',
    ar: 'المخزونات'
  },
  All: {
    en: 'All',
    fr: 'Tous',
    ar: 'الكل'
  },
  'Created by:': {
    en: 'Created by:',
    fr: 'Créé par:',
    ar: 'تم الإنشاء بواسطة:'
  },
  'Created At:': {
    en: 'Created At:',
    fr: 'Créé à:',
    ar: 'تم الإنشاء في:'
  },
  'Edit Category': {
    en: 'Edit Category',
    fr: 'Modifier la catégorie',
    ar: 'تحرير الفئة'
  },
  'Description:': {
    en: 'Description:',
    fr: 'Description:',
    ar: 'وصف:'
  },
  'Items:': {
    en: 'Items:',
    fr: 'Articles:',
    ar: 'العناصر:'
  },
  Cancel: {
    en: 'Cancel',
    fr: 'Annuler',
    ar: 'إلغاء'
  },
  Save: {
    en: 'Save',
    fr: 'Enregistrer',
    ar: 'حفظ'
  },
  Move: {
    en: 'Move',
    fr: 'Déplacer',
    ar: 'تحرك'
  },
  'Item already exists': {
    en: 'Item already exists',
    fr: "L'article existe déjà",
    ar: 'العنصر موجود بالفعل'
  },
  'An item with the same name or barcode already exists. Do you want to update it instead?':
    {
      en: 'An item with the same name or barcode already exists. Do you want to update it instead?',
      fr: 'Un article avec le même nom ou code-barres existe déjà. Voulez-vous le mettre à jour à la place ? ',
      ar: 'يوجد عنصر يحمل نفس الاسم أو الباركود. هل تريد تحديثه بدلاً من ذلك؟'
    },
  'Check Item': {
    en: 'Check Item',
    fr: "Vérifier l'article",
    ar: 'تحقق من العنصر'
  },
  'Quantity:': {
    en: 'Quantity:',
    fr: 'Quantité:',
    ar: 'كمية:'
  },
  'Min Level:': {
    en: 'Min Level:',
    fr: 'Niveau minimum:',
    ar: 'الحد الأدنى:'
  },
  'Selling Price:': {
    en: 'Selling Price:',
    fr: 'Prix de vente:',
    ar: 'سعر البيع:'
  },
  'Buying Price:': {
    en: 'Buying Price:',
    fr: "Prix d'achat:",
    ar: 'سعر الشراء:'
  },
  'Total Value:': {
    en: 'Total Value:',
    fr: 'Valeur totale:',
    ar: 'القيمة الإجمالية:'
  },
  'Upload Image:': {
    en: 'Upload Image:',
    fr: "Télécharger l'image:",
    ar: 'تحميل الصورة:'
  },
  'Tags:': {
    en: 'Tags:',
    fr: 'Mots clés:',
    ar: 'الكلمات:'
  },
  'Notes:': {
    en: 'Notes:',
    fr: 'Remarques:',
    ar: 'ملاحظات:'
  },
  'ADD ITEM': {
    en: 'ADD ITEM',
    fr: 'AJOUTER UN ARTICLE',
    ar: 'إضافة عنصر'
  },
  'ADD CATEGORY': {
    en: 'ADD CATEGORY',
    fr: 'AJOUTER UNE CATÉGORIE',
    ar: 'إضافة فئة'
  },
  'ADD FOLDER': {
    en: 'ADD FOLDER',
    fr: 'AJOUTER UN DOSSIER',
    ar: 'إضافة مجلد'
  },
  'Edit Item': {
    en: 'Edit Item',
    fr: "Modifier l'article",
    ar: 'تحرير العنصر'
  },
  'Reason:': {
    en: 'Reason:',
    fr: 'Raison:',
    ar: 'السبب:'
  },
  'No Category': {
    en: 'No Category',
    fr: 'Pas de catégorie',
    ar: 'بدون فئة'
  },
  'Categories:': {
    en: 'Categories:',
    fr: 'Catégories:',
    ar: 'الفئات:'
  },
  'Items Moved:': {
    en: 'Items Moved:',
    fr: 'Articles déplacés:',
    ar: 'العناصر المنقولة:'
  },
  'Modified by:': {
    en: 'Modified by:',
    fr: 'Modifié par:',
    ar: 'تم التعديل بواسطة:'
  },
  'Modified At:': {
    en: 'Modified At:',
    fr: 'Modifié à:',
    ar: 'تم التعديل في:'
  },
  Edit: {
    en: 'Edit',
    fr: 'Modifier',
    ar: 'تصحيح'
  },
  Delete: {
    en: 'Delete',
    fr: 'Effacer',
    ar: 'حذف'
  },
  selected: {
    en: 'selected',
    fr: 'sélectionné(s)',
    ar: 'المحدد(المحددون)'
  },
  'Deselect All': {
    en: 'Deselect All',
    fr: 'Désélectionner tout',
    ar: 'إلغاء تحديد الكل'
  },
  'Select All': {
    en: 'Select All',
    fr: 'Tout sélectionner',
    ar: 'اختر الكل'
  },
  'All items deleted': {
    en: 'All items deleted',
    fr: 'Tous les articles ont été supprimés',
    ar: 'تم حذف جميع العناصر'
  },
  'Move Selected': {
    en: 'Move Selected',
    fr: 'Déplacer la sélection',
    ar: 'نقل المحدد'
  },
  'Delete Selected': {
    en: 'Delete Selected',
    fr: 'Supprimer la sélection',
    ar: 'حذف المحدد'
  },
  'Deleted successfully': {
    en: 'Deleted successfully',
    fr: 'Supprimé avec succès',
    ar: 'تم الحذف بنجاح'
  },
  'Failed to delete item(s)': {
    en: 'Failed to delete item(s)',
    fr: 'Échec de la suppression de/des article(s)',
    ar: 'فشل حذف العنصر(العناصر)'
  },
  'Are you sure you want to delete {n} items?': {
    en: 'Are you sure you want to delete {n} items?',
    fr: 'Êtes-vous sûr de vouloir supprimer {n} articles ?',
    ar: 'هل أنت متأكد أنك تريد حذف {n} عناصر؟'
  },
  'Type:': {
    en: 'Type:',
    fr: 'Type:',
    ar: 'النوع:'
  },
  'Total Quantity:': {
    en: 'Total Quantity:',
    fr: 'Quantité totale:',
    ar: 'الكمية الإجمالية:'
  },
  Return: {
    en: 'Return',
    fr: 'Retour',
    ar: 'إرجاع'
  },
  'Available Items': {
    en: 'Available Items',
    fr: 'Articles disponibles',
    ar: 'العناصر المتاحة'
  },
  'Move Category': {
    en: 'Move Category',
    fr: 'Déplacer la catégorie',
    ar: 'نقل الفئة'
  },
  'Select Parent Category': {
    en: 'Select Parent Category',
    fr: 'Sélectionner la catégorie parent',
    ar: 'اختر الفئة الأم'
  },
  'Move Here': {
    en: 'Move Here',
    fr: 'Déplacer ici',
    ar: 'انقل هنا'
  },
  'Move Folder': {
    en: 'Move Folder',
    fr: 'Déplacer le dossier',
    ar: 'نقل المجلد'
  },
  'Edit Folder': {
    en: 'Edit Folder',
    fr: 'Modifier le dossier',
    ar: 'تحرير المجلد'
  },
  'Selling Price': {
    en: 'Selling Price',
    fr: 'Prix de vente',
    ar: 'سعر البيع'
  },
  'Buying Price': {
    en: 'Buying Price',
    fr: "Prix d'achat",
    ar: 'سعر الشراء'
  },
  'Minimum Level': {
    en: 'Min Level',
    fr: 'Niveau minimum',
    ar: 'الحد الأدنى'
  },
  'Min Level': {
    en: 'Min Level',
    fr: 'Niveau minimum',
    ar: 'الحد الأدنى'
  },
  Categories: {
    en: 'Categories',
    fr: 'Catégories',
    ar: 'التصنيفات'
  },
  'Alert on Low Inventory': {
    en: 'Alert on Low Inventory',
    fr: 'Alerte sur faible inventaire',
    ar: 'تنبيه على المخزون المنخفض'
  },
  'Upload Photo': {
    en: 'Upload Photo',
    fr: 'Télécharger une photo',
    ar: 'تحميل الصورة'
  },
  'Upload a photo file OR use the URL field below': {
    en: 'Upload a photo file OR use the URL field below',
    fr: 'Téléchargez une photo OU utilisez le champ URL ci-dessous',
    ar: 'قم برفع ملف صورة أو استخدم حقل الرابط أدناه'
  },
  'Print Barcodes': {
    en: 'Print Barcodes',
    fr: 'Imprimer les codes-barres',
    ar: 'طباعة الباركود'
  },
  'Set Quantities': {
    en: 'Set Quantities',
    fr: 'Définir les quantités',
    ar: 'تعيين الكميات'
  },
  'Print All Barcodes': {
    en: 'Print All Barcodes',
    fr: 'Tout imprimer (codes-barres)',
    ar: 'طباعة كل الباركود'
  },
  'Too many barcodes': {
    en: 'Too many barcodes',
    fr: 'Trop de codes-barres',
    ar: 'عدد كبير جدًا من الباركود'
  },
  "You can't print more than {n} barcodes in one PDF.": {
    en: "You can't print more than {n} barcodes in one PDF.",
    fr: 'Vous ne pouvez pas imprimer plus de {n} codes-barres dans un seul PDF.',
    ar: 'لا يمكنك طباعة أكثر من {n} باركود في ملف PDF واحد.'
  },
  Requested: {
    en: 'Requested',
    fr: 'Demandé',
    ar: 'المطلوب'
  },
  Limit: {
    en: 'Limit',
    fr: 'Limite',
    ar: 'الحد'
  },
  'Print All': {
    en: 'Print All',
    fr: 'Tout imprimer',
    ar: 'طباعة الكل'
  },
  'Requested quantity exceeds available': {
    en: 'Requested quantity exceeds available',
    fr: 'La quantité demandée dépasse le stock disponible',
    ar: 'الكمية المطلوبة تتجاوز المتاح'
  },
  'Insufficient Quantity': {
    en: 'Insufficient Quantity',
    fr: 'Quantité insuffisante',
    ar: 'الكمية غير كافية'
  },
  'has only': {
    en: 'has only',
    fr: "n'a que",
    ar: 'لديه فقط'
  },
  requested: {
    en: 'requested',
    fr: 'demandé',
    ar: 'مطلوب'
  },
  available: {
    en: 'available',
    fr: 'disponible',
    ar: 'متاح'
  },
  'The following items exceed available stock:': {
    en: 'The following items exceed available stock:',
    fr: 'Les articles suivants dépassent le stock disponible :',
    ar: 'العناصر التالية تتجاوز المخزون المتاح:'
  },
  OK: {
    en: 'OK',
    fr: 'OK',
    ar: 'حسنًا'
  },
  'No items selected': {
    en: 'No items selected',
    fr: 'Aucun élément sélectionné',
    ar: 'لا توجد عناصر محددة'
  },
  Loading: {
    en: 'Loading…',
    fr: 'Chargement…',
    ar: 'جاري التحميل…'
  },
  'Photo URL': {
    en: 'Photo URL',
    fr: 'URL de la photo',
    ar: 'رابط الصورة'
  },
  'Enter image URL OR upload a file above': {
    en: 'Enter image URL OR upload a file above',
    fr: "Saisissez l'URL de l'image OU téléversez un fichier ci-dessus",
    ar: 'أدخل رابط الصورة أو قم برفع ملف بالأعلى'
  },
  'Item Image': {
    en: 'Item Image',
    fr: "Image de l'article",
    ar: 'صورة العنصر'
  },
  'Custom Fields (JSON)': {
    en: 'Custom Fields (JSON)',
    fr: 'Champs personnalisés (JSON)',
    ar: 'الحقول المخصصة (JSON)'
  },
  'Custom Fields': {
    en: 'Custom Fields',
    fr: 'Champs personnalisés',
    ar: 'الحقول المخصصة'
  },
  'Custom Field Label': {
    en: 'Custom Field Label',
    fr: 'Libellé du champ personnalisé',
    ar: 'تسمية الحقل المخصص'
  },
  'Custom Field Value': {
    en: 'Custom Field Value',
    fr: 'Valeur du champ personnalisé',
    ar: 'قيمة الحقل المخصص'
  },
  'Field Label': {
    en: 'Field Label',
    fr: 'Libellé du champ',
    ar: 'تسمية الحقل'
  },
  'Field Value': {
    en: 'Field Value',
    fr: 'Valeur du champ',
    ar: 'قيمة الحقل'
  },
  'Add Custom Field': {
    en: 'Add Custom Field',
    fr: 'Ajouter un champ personnalisé',
    ar: 'إضافة حقل مخصص'
  },
  'Remove Field': {
    en: 'Remove Field',
    fr: 'Supprimer le champ',
    ar: 'إزالة الحقل'
  },
  Field: {
    en: 'Field',
    fr: 'Champ',
    ar: 'حقل'
  },
  Notes: {
    en: 'Notes',
    fr: 'Remarques',
    ar: 'ملاحظات'
  },
  'QR Code': {
    en: 'QR Code',
    fr: 'Code QR',
    ar: 'رمز الاستجابة السريعة'
  },
  'Select Categories': {
    en: 'Select Categories',
    fr: 'Sélectionner les catégories',
    ar: 'اختر الفئات'
  },
  'Organization ID': {
    en: 'Organization ID',
    fr: "ID de l'organisation",
    ar: 'معرف المنظمة'
  },
  'Quantity to move': {
    en: 'Quantity to move',
    fr: 'Quantité à déplacer',
    ar: 'الكمية المراد نقلها'
  },
  'Move reason': {
    en: 'Move reason',
    fr: 'Raison du déplacement',
    ar: 'سبب التحرك'
  },
  'Select Item': {
    en: 'Select Item',
    fr: 'Sélectionner un article',
    ar: 'اختر العنصر'
  },
  'Move notes': {
    en: 'Move notes',
    fr: 'Notes de déplacement',
    ar: 'ملاحظات التحرك'
  },
  Description: {
    en: 'Description',
    fr: 'Description',
    ar: 'وصف'
  },
  'Select Items': {
    en: 'Select Items',
    fr: 'Sélectionner les articles',
    ar: 'اختر العناصر'
  },
  'New Item': {
    en: 'New Item',
    fr: 'Nouvel article',
    ar: 'عنصر جديد'
  },
  'Parent Category': {
    en: 'Parent Category',
    fr: 'Catégorie parent',
    ar: 'الفئة الأم'
  },
  'Select Category Parent': {
    en: 'Select Category Parent',
    fr: 'Sélectionner la catégorie parent',
    ar: 'اختر الفئة الأم'
  },
  Subtract: {
    en: 'Subtract',
    fr: 'Soustraire',
    ar: 'طرح'
  },
  'Add Folder': {
    en: 'Add Folder',
    fr: 'Ajouter un dossier',
    ar: 'إضافة مجلد'
  },
  'New Folder': {
    en: 'New Folder',
    fr: 'Nouveau dossier',
    ar: 'مجلد جديد'
  },
  'Select Parent Folder': {
    en: 'Select Parent Folder',
    fr: 'Sélectionner le dossier parent',
    ar: 'اختر المجلد الأم'
  },
  'Parent Folder': {
    en: 'Parent Folder',
    fr: 'Dossier parent',
    ar: 'المجلد الأم'
  },
  'Sort by': {
    en: 'Sort by',
    fr: 'Trier par',
    ar: 'ترتيب حسب'
  },
  'Bulk Item Creation': {
    en: 'Bulk Item Creation',
    fr: "Création d'articles en masse",
    ar: 'إنشاء عناصر بالجملة'
  },
  'Folders Structure': {
    en: 'Folders Structure',
    fr: 'Structure des dossiers',
    ar: 'هيكل المجلدات'
  },
  'Categories Structure': {
    en: 'Categories Structure',
    fr: 'Structure des catégories',
    ar: 'هيكل الفئات'
  },
  'Architecture Type': {
    en: 'Architecture Type',
    fr: "Type d'architecture",
    ar: 'نوع الهيكلية'
  },
  'Refresh Current Architecture': {
    en: 'Refresh Current Architecture',
    fr: "Actualiser l'architecture actuelle",
    ar: 'تحديث الهيكلية الحالية'
  },
  'Select Architecture Type': {
    en: 'Select Architecture Type',
    fr: "Sélectionner le type d'architecture",
    ar: 'اختر نوع الهيكلية'
  },
  'Setup your categories and folders structure quickly': {
    en: 'Setup your categories and folders structure quickly',
    fr: 'Configurez rapidement la structure de vos catégories et dossiers',
    ar: 'قم بإعداد هيكل الفئات والمجلدات الخاصة بك بسرعة'
  },
  'Loading Architecture': {
    en: 'Loading Architecture',
    fr: "Chargement de l'architecture",
    ar: 'تحميل الهيكلية'
  },
  "We're working on something amazing!": {
    en: "We're working on something amazing!",
    fr: "Nous travaillons sur quelque chose d'incroyable !",
    ar: 'نحن نعمل على شيء مذهل!'
  },
  'Bulk Architecture Setup': {
    en: 'Bulk Architecture Setup',
    fr: "Configuration d'architecture en masse",
    ar: 'إعداد الهيكلية بالجملة'
  },
  'Development in Progress...': {
    en: 'Development in Progress...',
    fr: 'Développement en cours...',
    ar: 'تطوير قيد التقدم...'
  },
  'Export Format': {
    en: 'Export Format',
    fr: "Format d'exportation",
    ar: 'صيغة التصدير'
  },
  'This feature is currently under development. Stay tuned for exciting updates.':
    {
      en: 'This feature is currently under development. Stay tuned for exciting updates.',
      fr: "Cette fonctionnalité est actuellement en cours de développement. Restez à l'écoute pour des mises à jour passionnantes.",
      ar: 'هذه الميزة قيد التطوير حاليًا. تابعنا للحصول على تحديثات مثيرة.'
    },
  'Coming Soon': {
    en: 'Coming Soon',
    fr: 'Bientôt disponible',
    ar: 'قريباً'
  },
  Export: {
    en: 'Export',
    fr: 'Exporter',
    ar: 'تصدير'
  },
  'Search by Tag or Item': {
    en: 'Search by Tag or Item',
    fr: 'Rechercher par étiquette ou article',
    ar: 'البحث حسب العلامة أو العنصر'
  },
  'Select a report type and click "Generate" to view data': {
    en: 'Select a report type and click "Generate" to view data',
    fr: 'Sélectionnez un type de rapport et cliquez sur "Générer" pour afficher les données',
    ar: 'حدد نوع التقرير وانقر على "إنشاء" لعرض البيانات'
  },
  Generate: {
    en: 'Generate',
    fr: 'Générer',
    ar: 'إنشاء'
  },
  'No Report Generated': {
    en: 'No Report Generated',
    fr: 'Aucun rapport généré',
    ar: 'لم يتم إنشاء تقرير'
  },
  'Select Report Type': {
    en: 'Select Report Type',
    fr: 'Sélectionner le type de rapport',
    ar: 'اختر نوع التقرير'
  },
  'Reports & Analytics': {
    en: 'Reports & Analytics',
    fr: 'Rapports et analyses',
    ar: 'التقارير والتحليلات'
  },
  'Generate inventory reports, review performance, and export data.': {
    en: 'Generate inventory reports, review performance, and export data.',
    fr: 'Générez des rapports d’inventaire, analysez les performances et exportez les données.',
    ar: 'أنشئ تقارير المخزون وراجع الأداء وصدّر البيانات.'
  },
  'No report selected': {
    en: 'No report selected',
    fr: 'Aucun rapport sélectionné',
    ar: 'لم يتم اختيار تقرير'
  },
  Excel: {
    en: 'Excel',
    fr: 'Excel',
    ar: 'إكسل'
  },
  'Start Date': {
    en: 'Start Date',
    fr: 'Date de début',
    ar: 'تاريخ البداية'
  },
  'End Date': {
    en: 'End Date',
    fr: 'Date de fin',
    ar: 'تاريخ النهاية'
  },
  'Search data': {
    en: 'Search data',
    fr: 'Rechercher dans les données',
    ar: 'البحث في البيانات'
  },
  'Select a report type, apply filters if needed, then generate the report.': {
    en: 'Select a report type, apply filters if needed, then generate the report.',
    fr: 'Sélectionnez un type de rapport, appliquez des filtres si nécessaire, puis générez le rapport.',
    ar: 'اختر نوع التقرير، وطبّق الفلاتر إذا لزم الأمر، ثم أنشئ التقرير.'
  },
  'Generating report...': {
    en: 'Generating report...',
    fr: 'Génération du rapport...',
    ar: 'جارٍ إنشاء التقرير...'
  },
  'Your report data is being prepared.': {
    en: 'Your report data is being prepared.',
    fr: 'Les données de votre rapport sont en cours de préparation.',
    ar: 'يتم تجهيز بيانات تقريرك.'
  },
  'Inventory Valuation': {
    en: 'Inventory Valuation',
    fr: "Valorisation de l'inventaire",
    ar: 'تقييم المخزون'
  },
  'Financial overview and stock status based on your inventory data.': {
    en: 'Financial overview and stock status based on your inventory data.',
    fr: "Aperçu financier et état du stock basés sur vos données d'inventaire.",
    ar: 'نظرة مالية عامة وحالة المخزون بناءً على بيانات المخزون لديك.'
  },
  Valuation: {
    en: 'Valuation',
    fr: 'Valorisation',
    ar: 'التقييم'
  },
  'Financial Overview': {
    en: 'Financial Overview',
    fr: 'Aperçu financier',
    ar: 'نظرة مالية عامة'
  },
  'Total Buying Value': {
    en: 'Total Buying Value',
    fr: "Valeur totale d'achat",
    ar: 'إجمالي قيمة الشراء'
  },
  'Total Selling Value': {
    en: 'Total Selling Value',
    fr: 'Valeur totale de vente',
    ar: 'إجمالي قيمة البيع'
  },
  'Potential Profit': {
    en: 'Potential Profit',
    fr: 'Bénéfice potentiel',
    ar: 'الربح المحتمل'
  },
  'Stock Status': {
    en: 'Stock Status',
    fr: 'État du stock',
    ar: 'حالة المخزون'
  },
  'Out of Stock Items': {
    en: 'Out of Stock Items',
    fr: 'Articles en rupture de stock',
    ar: 'العناصر غير المتوفرة في المخزون'
  },
  'Out Of Stock Items': {
    en: 'Out Of Stock Items',
    fr: 'Articles en rupture de stock',
    ar: 'العناصر غير المتوفرة في المخزون'
  },
  'Average Value per Item': {
    en: 'Average Value per Item',
    fr: 'Valeur moyenne par article',
    ar: 'متوسط القيمة لكل عنصر'
  },
  'Average Value Per Item': {
    en: 'Average Value Per Item',
    fr: 'Valeur moyenne par article',
    ar: 'متوسط القيمة لكل عنصر'
  },
  'Total Items Across Categories': {
    en: 'Total Items Across Categories',
    fr: 'Total des articles dans les catégories',
    ar: 'إجمالي العناصر عبر الفئات'
  },
  'Total Value Across Categories': {
    en: 'Total Value Across Categories',
    fr: 'Valeur totale dans les catégories',
    ar: 'إجمالي القيمة عبر الفئات'
  },
  'Average Items Per Category': {
    en: 'Average Items Per Category',
    fr: 'Nombre moyen d’articles par catégorie',
    ar: 'متوسط العناصر لكل فئة'
  },
  'Categories With Items': {
    en: 'Categories With Items',
    fr: 'Catégories avec articles',
    ar: 'الفئات التي تحتوي على عناصر'
  },
  'Empty Categories': {
    en: 'Empty Categories',
    fr: 'Catégories vides',
    ar: 'الفئات الفارغة'
  },
  'Total Transactions': {
    en: 'Total Transactions',
    fr: 'Total des transactions',
    ar: 'إجمالي المعاملات'
  },
  'Total Quantity Sold': {
    en: 'Total Quantity Sold',
    fr: 'Quantité totale vendue',
    ar: 'إجمالي الكمية المباعة'
  },
  'Total Revenue': {
    en: 'Total Revenue',
    fr: 'Revenu total',
    ar: 'إجمالي الإيرادات'
  },
  'Average Transaction Value': {
    en: 'Average Transaction Value',
    fr: 'Valeur moyenne des transactions',
    ar: 'متوسط قيمة المعاملة'
  },
  'Unique Items Sold': {
    en: 'Unique Items Sold',
    fr: 'Articles uniques vendus',
    ar: 'العناصر الفريدة المباعة'
  },
  'Categories Count': {
    en: 'Categories Count',
    fr: 'Nombre de catégories',
    ar: 'عدد الفئات'
  },
  'Total Low Stock Items': {
    en: 'Total Low Stock Items',
    fr: 'Total des articles à stock faible',
    ar: 'إجمالي عناصر المخزون المنخفض'
  },
  'Total Value At Risk': {
    en: 'Total Value At Risk',
    fr: 'Valeur totale à risque',
    ar: 'إجمالي القيمة المعرضة للخطر'
  },
  'Critical Items': {
    en: 'Critical Items',
    fr: 'Articles critiques',
    ar: 'العناصر الحرجة'
  },
  'Items Needing Restock': {
    en: 'Items Needing Restock',
    fr: 'Articles nécessitant un réapprovisionnement',
    ar: 'العناصر التي تحتاج إلى إعادة التزويد'
  },
  'Report Data': {
    en: 'Report Data',
    fr: 'Données du rapport',
    ar: 'بيانات التقرير'
  },
  'Review generated report rows and export them when needed.': {
    en: 'Review generated report rows and export them when needed.',
    fr: 'Consultez les lignes du rapport généré et exportez-les au besoin.',
    ar: 'راجع صفوف التقرير المنشأ وصدّرها عند الحاجة.'
  },
  rows: {
    en: 'rows',
    fr: 'lignes',
    ar: 'صفوف'
  },
  'No data found': {
    en: 'No data found',
    fr: 'Aucune donnée trouvée',
    ar: 'لم يتم العثور على بيانات'
  },
  'Try changing the report type or filters.': {
    en: 'Try changing the report type or filters.',
    fr: 'Essayez de modifier le type de rapport ou les filtres.',
    ar: 'جرّب تغيير نوع التقرير أو الفلاتر.'
  },
  'Items Report': {
    en: 'Items Report',
    fr: 'Rapport des articles',
    ar: 'تقرير العناصر'
  },
  'Categories Report': {
    en: 'Categories Report',
    fr: 'Rapport des catégories',
    ar: 'تقرير الفئات'
  },
  'Sold Items Report': {
    en: 'Sold Items Report',
    fr: 'Rapport des articles vendus',
    ar: 'تقرير العناصر المباعة'
  },
  'Low Stock Report': {
    en: 'Low Stock Report',
    fr: 'Rapport de stock faible',
    ar: 'تقرير المخزون المنخفض'
  },
  'Inventory items with quantity, price, status, and category details.': {
    en: 'Inventory items with quantity, price, status, and category details.',
    fr: 'Articles en inventaire avec quantité, prix, état et détails de catégorie.',
    ar: 'عناصر المخزون مع الكمية والسعر والحالة وتفاصيل الفئة.'
  },
  'Category performance with item counts, values, and ownership details.': {
    en: 'Category performance with item counts, values, and ownership details.',
    fr: "Performance des catégories avec nombre d'articles, valeurs et détails de propriété.",
    ar: 'أداء الفئات مع أعداد العناصر والقيم وتفاصيل الملكية.'
  },
  'Sold item activity with quantities, values, dates, and creators.': {
    en: 'Sold item activity with quantities, values, dates, and creators.',
    fr: 'Activité des articles vendus avec quantités, valeurs, dates et créateurs.',
    ar: 'نشاط العناصر المباعة مع الكميات والقيم والتواريخ ومنشئي السجلات.'
  },
  'Items that are below minimum stock levels and need attention.': {
    en: 'Items that are below minimum stock levels and need attention.',
    fr: 'Articles sous les niveaux de stock minimum et nécessitant une attention.',
    ar: 'العناصر التي تقل عن الحد الأدنى للمخزون وتحتاج إلى انتباه.'
  },
  'Financial valuation of buying value, selling value, and potential profit.': {
    en: 'Financial valuation of buying value, selling value, and potential profit.',
    fr: "Valorisation financière de la valeur d'achat, de la valeur de vente et du bénéfice potentiel.",
    ar: 'تقييم مالي لقيمة الشراء وقيمة البيع والربح المحتمل.'
  },
  'Item Count': {
    en: 'Item Count',
    fr: "Nombre d'articles",
    ar: 'عدد العناصر'
  },
  'Child Categories': {
    en: 'Child Categories',
    fr: 'Sous-catégories',
    ar: 'الفئات الفرعية'
  },
  'Report generated successfully': {
    en: 'Report generated successfully',
    fr: 'Rapport généré avec succès',
    ar: 'تم إنشاء التقرير بنجاح'
  },
  'Report exported successfully': {
    en: 'Report exported successfully',
    fr: 'Rapport exporté avec succès',
    ar: 'تم تصدير التقرير بنجاح'
  },
  'Failed to load report types': {
    en: 'Failed to load report types',
    fr: 'Échec du chargement des types de rapport',
    ar: 'فشل تحميل أنواع التقارير'
  },
  'Failed to generate report': {
    en: 'Failed to generate report',
    fr: 'Échec de la génération du rapport',
    ar: 'فشل إنشاء التقرير'
  },
  'Failed to export report': {
    en: 'Failed to export report',
    fr: "Échec de l'exportation du rapport",
    ar: 'فشل تصدير التقرير'
  },
  'New Category': {
    en: 'New Category',
    fr: 'Nouvelle catégorie',
    ar: 'فئة جديدة'
  },
  'Alert on Low Inventory:': {
    en: 'Alert on Low Inventory:',
    fr: 'Alerte sur faible inventaire:',
    ar: 'تنبيه على المخزون المنخفض:'
  },
  'Created By': {
    en: 'Created By',
    fr: 'Créé par',
    ar: 'تم الإنشاء بواسطة'
  },
  'Created At': {
    en: 'Created At',
    fr: 'Créé à',
    ar: 'تم الإنشاء في'
  },
  'Add Tag': {
    en: 'Add Tag',
    fr: 'Ajouter une étiquette',
    ar: 'إضافة علامة'
  },
  Notifications: {
    en: 'Notifications',
    fr: 'Notifications',
    ar: 'الإشعارات'
  },
  'Alerts: Low on Stock': {
    en: 'Alerts: Low on Stock',
    fr: 'Alertes: Faible en stock',
    ar: 'تنبيهات: منخفضة في الأسهم'
  },
  'is low on stock': {
    en: 'is low on stock',
    fr: 'est faible en stock',
    ar: 'منخفض في الأسهم'
  },
  Batches: {
    en: 'Batches',
    fr: 'Lots',
    ar: 'الدفعات'
  },
  'SKU:': {
    en: 'SKU:',
    fr: 'UGS:',
    ar: 'وحدة حفظ المخزون:'
  },
  'Leave empty for auto-generation': {
    en: 'Leave empty for auto-generation',
    fr: 'Laisser vide pour la génération automatique',
    ar: 'اتركه فارغًا للإنشاء التلقائي'
  },
  'Audit Logs': {
    en: 'Audit Logs',
    fr: "Journaux d'audit",
    ar: 'سجلات المراجعة'
  },
  'Search items, categories, folders...': {
    en: 'Search items, categories, folders...',
    fr: 'Rechercher des articles, catégories, dossiers...',
    ar: 'البحث في العناصر والفئات والمجلدات...'
  },
  'Light Theme': {
    en: 'Light Theme',
    fr: 'Thème clair',
    ar: 'السمة الفاتحة'
  },
  'Dark Theme': {
    en: 'Dark Theme',
    fr: 'Thème sombre',
    ar: 'السمة الداكنة'
  },
  Language: {
    en: 'Language',
    fr: 'Langue',
    ar: 'اللغة'
  },
  Refresh: {
    en: 'Refresh',
    fr: 'Actualiser',
    ar: 'تحديث'
  },
  'from last month': {
    en: 'from last month',
    fr: 'du mois dernier',
    ar: 'من الشهر الماضي'
  },
  'Inventory Trends': {
    en: 'Inventory Trends',
    fr: "Tendances de l'inventaire",
    ar: 'اتجاهات المخزون'
  },
  'Items Added': {
    en: 'Items Added',
    fr: 'Articles ajoutés',
    ar: 'العناصر المضافة'
  },
  'Stock Levels': {
    en: 'Stock Levels',
    fr: 'Niveaux de stock',
    ar: 'مستويات المخزون'
  },
  'Stock Distribution': {
    en: 'Stock Distribution',
    fr: 'Distribution du stock',
    ar: 'توزيع المخزون'
  },
  'Recent Activity': {
    en: 'Recent Activity',
    fr: 'Activité récente',
    ar: 'النشاط الأخير'
  },
  Type: {
    en: 'Type',
    fr: 'Type',
    ar: 'النوع'
  },
  Details: {
    en: 'Details',
    fr: 'Détails',
    ar: 'التفاصيل'
  },
  Unknown: {
    en: 'Unknown',
    fr: 'Inconnu',
    ar: 'غير معروف'
  },
  'No recent activity': {
    en: 'No recent activity',
    fr: 'Aucune activité récente',
    ar: 'لا توجد أنشطة حديثة'
  },
  'Unknown User': {
    en: 'Unknown User',
    fr: 'Utilisateur inconnu',
    ar: 'مستخدم غير معروف'
  },
  'Low Stock Alert': {
    en: 'Low Stock Alert',
    fr: 'Alerte de stock faible',
    ar: 'تنبيه المخزون المنخفض'
  },
  items: {
    en: 'items',
    fr: 'articles',
    ar: 'عناصر'
  },
  'Current stock': {
    en: 'Current stock',
    fr: 'Stock actuel',
    ar: 'المخزون الحالي'
  },
  'View all': {
    en: 'View all',
    fr: 'Voir tout',
    ar: 'عرض الكل'
  },
  'Quick Actions': {
    en: 'Quick Actions',
    fr: 'Actions rapides',
    ar: 'الإجراءات السريعة'
  },
  Actions: {
    en: 'Actions',
    fr: 'Actions',
    ar: 'الإجراءات'
  },
  'Add New Item': {
    en: 'Add New Item',
    fr: 'Ajouter un nouvel article',
    ar: 'إضافة عنصر جديد'
  },
  'View All Items': {
    en: 'View All Items',
    fr: 'Voir tous les articles',
    ar: 'عرض جميع العناصر'
  },
  'View All Categories': {
    en: 'View all Categories',
    fr: 'Voir toutes les catégories',
    ar: 'عرض جميع الفئات'
  },
  'Generate Report': {
    en: 'Generate Report',
    fr: 'Générer un rapport',
    ar: 'إنشاء تقرير'
  },
  'View all notifications': {
    en: 'View all notifications',
    fr: 'Voir toutes les notifications',
    ar: 'عرض جميع الإشعارات'
  },
  'Categories Overview': {
    en: 'Categories Overview',
    fr: 'Aperçu des catégories',
    ar: 'نظرة عامة على الفئات'
  },
  'View all categories': {
    en: 'View all categories',
    fr: 'Voir toutes les catégories',
    ar: 'عرض جميع الفئات'
  },
  'Select Language': {
    en: 'Select Language',
    fr: 'Sélectionner la langue',
    ar: 'اختر اللغة'
  },
  English: {
    en: 'English',
    fr: 'Anglais',
    ar: 'الإنجليزية'
  },
  Français: {
    en: 'Français',
    fr: 'Français',
    ar: 'الفرنسية'
  },
  'High Stock': {
    en: 'High Stock',
    fr: 'Stock élevé',
    ar: 'مخزون عالي'
  },
  'Normal Stock': {
    en: 'Normal Stock',
    fr: 'Stock normal',
    ar: 'مخزون عادي'
  },
  Reorder: {
    en: 'Reorder',
    fr: 'Réapprovisionner',
    ar: 'إعادة طلب'
  },
  'Out of Stock Alert': {
    en: 'Out of Stock Alert',
    fr: 'Alerte de rupture de stock',
    ar: 'تنبيه نفاد المخزون'
  },
  'are out of stock': {
    en: 'are out of stock',
    fr: 'sont en rupture de stock',
    ar: 'نفدت من المخزون'
  },
  'Restock Reminder': {
    en: 'Restock Reminder',
    fr: 'Rappel de réapprovisionnement',
    ar: 'تذكير إعادة التخزين'
  },
  'should be restocked soon': {
    en: 'should be restocked soon',
    fr: 'doivent être réapprovisionnés bientôt',
    ar: 'يجب إعادة تخزينها قريباً'
  },
  total: {
    en: 'total',
    fr: 'total',
    ar: 'المجموع'
  },
  'No categories yet. Add your first category or select a preset above.': {
    en: 'No categories yet. Add your first category or select a preset above.',
    fr: 'Pas encore de catégories. Ajoutez votre première catégorie ou sélectionnez un modèle ci-dessus.',
    ar: 'لا توجد فئات بعد. أضف فئتك الأولى أو اختر نموذجاً أعلاه.'
  },
  'No folders yet. Add your first folder or select a preset above.': {
    en: 'No folders yet. Add your first folder or select a preset above.',
    fr: 'Pas encore de dossiers. Ajoutez votre premier dossier ou sélectionnez un modèle ci-dessus.',
    ar: 'لا توجد مجلدات بعد. أضف مجلدك الأول أو اختر نموذجاً أعلاه.'
  },
  'No items yet. Click the + button to add your first item.': {
    en: 'No items yet. Click the + button to add your first item.',
    fr: "Pas encore d'articles. Cliquez sur le bouton + pour ajouter votre premier article.",
    ar: 'لا توجد عناصر بعد. انقر على زر + لإضافة عنصرك الأول.'
  },
  'items in batch': {
    en: 'items in batch',
    fr: 'articles dans le lot',
    ar: 'عناصر في الدفعة'
  },
  'from Excel': {
    en: 'from Excel',
    fr: 'depuis Excel',
    ar: 'من Excel'
  },
  'Default Categories for Items': {
    en: 'Default Categories for Items',
    fr: 'Catégories par défaut pour les articles',
    ar: 'الفئات الافتراضية للعناصر'
  },
  'Applied to all new items by default': {
    en: 'Applied to all new items by default',
    fr: 'Appliqué à tous les nouveaux articles par défaut',
    ar: 'يطبق على جميع العناصر الجديدة افتراضياً'
  },
  'Select categories': {
    en: 'Select categories',
    fr: 'Sélectionner les catégories',
    ar: 'اختر الفئات'
  },
  'Add Row': {
    en: 'Add Row',
    fr: 'Ajouter une ligne',
    ar: 'إضافة صف'
  },
  'Add 5 Rows': {
    en: 'Add 5 Rows',
    fr: 'Ajouter 5 lignes',
    ar: 'إضافة 5 صفوف'
  },
  'Clear All': {
    en: 'Clear All',
    fr: 'Effacer tout',
    ar: 'مسح الكل'
  },
  'Create current and load next': {
    en: 'Create current and load next',
    fr: 'Créer le lot courant et charger le suivant',
    ar: 'أنشئ الحالي وحمّل التالي'
  },
  'Individual Actions': {
    en: 'Individual Actions',
    fr: 'Actions individuelles',
    ar: 'الإجراءات الفردية'
  },
  'Bulk Actions': {
    en: 'Bulk Actions',
    fr: 'Actions en masse',
    ar: 'الإجراءات الجماعية'
  },
  'Preview Category Changes': {
    en: 'Preview Category Changes',
    fr: 'Aperçu des modifications de catégorie',
    ar: 'معاينة تغييرات الفئة'
  },
  'No Category Changes': {
    en: 'No Category Changes',
    fr: 'Aucune modification de catégorie',
    ar: 'لا توجد تغييرات في الفئة'
  },
  'Preview Folder Changes': {
    en: 'Preview Folder Changes',
    fr: 'Aperçu des modifications de dossier',
    ar: 'معاينة تغييرات المجلد'
  },
  'No Folder Changes': {
    en: 'No Folder Changes',
    fr: 'Aucune modification de dossier',
    ar: 'لا توجد تغييرات في المجلد'
  },
  'Preview Item Creation': {
    en: 'Preview Item Creation',
    fr: "Aperçu de la création d'article",
    ar: 'معاينة إنشاء العنصر'
  },
  'No Valid Items': {
    en: 'No Valid Items',
    fr: 'Aucun article valide',
    ar: 'لا توجد عناصر صالحة'
  },
  'Show Changes': {
    en: 'Show Changes',
    fr: 'Afficher les modifications',
    ar: 'إظهار التغييرات'
  },
  'Apply All Changes': {
    en: 'Apply All Changes',
    fr: 'Appliquer toutes les modifications',
    ar: 'تطبيق جميع التغييرات'
  },
  'Create All Architecture': {
    en: 'Create All Architecture',
    fr: "Créer toute l'architecture",
    ar: 'إنشاء كامل الهيكلية'
  },
  'Reset All': {
    en: 'Reset All',
    fr: 'Réinitialiser tout',
    ar: 'إعادة تعيين الكل'
  },
  'Creating Architecture': {
    en: 'Creating Architecture',
    fr: "Création de l'architecture",
    ar: 'إنشاء الهيكلية'
  },
  'Architecture Changes Preview': {
    en: 'Architecture Changes Preview',
    fr: "Aperçu des modifications de l'architecture",
    ar: 'معاينة تغييرات الهيكلية'
  },
  'Categories Changes': {
    en: 'Categories Changes',
    fr: 'Modifications des catégories',
    ar: 'تغييرات الفئات'
  },
  'New Categories': {
    en: 'New Categories',
    fr: 'Nouvelles catégories',
    ar: 'فئات جديدة'
  },
  'Updated Categories': {
    en: 'Updated Categories',
    fr: 'Catégories mises à jour',
    ar: 'فئات محدثة'
  },
  'Deleted Categories': {
    en: 'Deleted Categories',
    fr: 'Catégories supprimées',
    ar: 'فئات محذوفة'
  },
  'No category changes': {
    en: 'No category changes',
    fr: 'Aucune modification de catégorie',
    ar: 'لا توجد تغييرات في الفئة'
  },
  'Folders Changes': {
    en: 'Folders Changes',
    fr: 'Modifications des dossiers',
    ar: 'تغييرات المجلدات'
  },
  'New Folders': {
    en: 'New Folders',
    fr: 'Nouveaux dossiers',
    ar: 'مجلدات جديدة'
  },
  'Updated Folders': {
    en: 'Updated Folders',
    fr: 'Dossiers mis à jour',
    ar: 'مجلدات محدثة'
  },
  'Deleted Folders': {
    en: 'Deleted Folders',
    fr: 'Dossiers supprimés',
    ar: 'مجلدات محذوفة'
  },
  'No folder changes': {
    en: 'No folder changes',
    fr: 'Aucune modification de dossier',
    ar: 'لا توجد تغييرات في المجلد'
  },
  'Apply Changes': {
    en: 'Apply Changes',
    fr: 'Appliquer les modifications',
    ar: 'تطبيق التغييرات'
  },
  'Operation Complete': {
    en: 'Operation Complete',
    fr: 'Opération terminée',
    ar: 'اكتملت العملية'
  },
  'Categories Results': {
    en: 'Categories Results',
    fr: 'Résultats des catégories',
    ar: 'نتائج الفئات'
  },
  'Folders Results': {
    en: 'Folders Results',
    fr: 'Résultats des dossiers',
    ar: 'نتائج المجلدات'
  },
  'Category Changes Preview': {
    en: 'Category Changes Preview',
    fr: 'Aperçu des modifications de catégorie',
    ar: 'معاينة تغييرات الفئة'
  },
  'Folder Changes Preview': {
    en: 'Folder Changes Preview',
    fr: 'Aperçu des modifications de dossier',
    ar: 'معاينة تغييرات المجلد'
  },
  'No category changes to apply': {
    en: 'No category changes to apply',
    fr: 'Aucune modification de catégorie à appliquer',
    ar: 'لا توجد تغييرات فئة للتطبيق'
  },
  'No folder changes to apply': {
    en: 'No folder changes to apply',
    fr: 'Aucune modification de dossier à appliquer',
    ar: 'لا توجد تغييرات مجلد للتطبيق'
  },
  'Items Created Successfully': {
    en: 'Items Created Successfully',
    fr: 'Articles créés avec succès',
    ar: 'تم إنشاء العناصر بنجاح'
  },
  'Categories created': {
    en: 'Categories created',
    fr: 'Catégories créées',
    ar: 'تم إنشاء الفئات'
  },
  'Folders created': {
    en: 'Folders created',
    fr: 'Dossiers créés',
    ar: 'تم إنشاء المجلدات'
  },
  'Items created': {
    en: 'Items created',
    fr: 'Articles créés',
    ar: 'تم إنشاء العناصر'
  },
  'Batch Item Creation Results': {
    en: 'Batch Item Creation Results',
    fr: "Résultats de création d'articles en lot",
    ar: 'نتائج إنشاء العناصر بالدفعة'
  },
  'Successfully Created': {
    en: 'Successfully Created',
    fr: 'Créé avec succès',
    ar: 'تم الإنشاء بنجاح'
  },
  'Auto-generated': {
    en: 'Auto-generated',
    fr: 'Généré automatiquement',
    ar: 'تم إنشاؤه تلقائياً'
  },
  'Failed to Create': {
    en: 'Failed to Create',
    fr: 'Échec de la création',
    ar: 'فشل في الإنشاء'
  },
  'Enter item name': {
    en: 'Enter item name',
    fr: "Entrez le nom de l'article",
    ar: 'أدخل اسم العنصر'
  },
  'Item description': {
    en: 'Item description',
    fr: "Description de l'article",
    ar: 'وصف العنصر'
  },
  Under: {
    en: 'Under',
    fr: 'Sous',
    ar: 'تحت'
  },
  'Excel Import/Export': {
    en: 'Excel Import/Export',
    fr: 'Import/Export Excel',
    ar: 'استيراد/تصدير إكسل'
  },
  'Download Template': {
    en: 'Download Template',
    fr: 'Télécharger le modèle',
    ar: 'تحميل النموذج'
  },
  'Upload Excel File': {
    en: 'Upload Excel File',
    fr: 'Télécharger fichier Excel',
    ar: 'رفع ملف إكسل'
  },
  'Enter barcode': {
    en: 'Enter barcode',
    fr: 'Entrez le code-barres',
    ar: 'أدخل الرمز الشريطي'
  },
  Barcode: {
    en: 'Barcode',
    fr: 'Code-barres',
    ar: 'الرمز الشريطي'
  },
  'Detailed insights into your inventory performance': {
    en: 'Detailed insights into your inventory performance',
    fr: 'Aperçus détaillés sur les performances de votre inventaire',
    ar: 'رؤى مفصلة حول أداء المخزون الخاص بك'
  },
  'Last 7 Days': {
    en: 'Last 7 Days',
    fr: '7 derniers jours',
    ar: 'آخر 7 أيام'
  },
  'Last 30 Days': {
    en: 'Last 30 Days',
    fr: '30 derniers jours',
    ar: 'آخر 30 يوماً'
  },
  'Last 90 Days': {
    en: 'Last 90 Days',
    fr: '90 derniers jours',
    ar: 'آخر 90 يوماً'
  },
  'Total Items': {
    en: 'Total Items',
    fr: 'Total des articles',
    ar: 'إجمالي العناصر'
  },
  'Low Stock Items': {
    en: 'Low Stock Items',
    fr: 'Articles en rupture de stock',
    ar: 'عناصر مخزون منخفض'
  },
  'Out of Stock': {
    en: 'Out of Stock',
    fr: 'En rupture de stock',
    ar: 'نفاد المخزون'
  },
  'Total Categories': {
    en: 'Total Categories',
    fr: 'Total des catégories',
    ar: 'إجمالي الفئات'
  },
  'Stock Health Distribution': {
    en: 'Stock Health Distribution',
    fr: 'Distribution de la santé du stock',
    ar: 'توزيع صحة المخزون'
  },
  'Inventory Value Analysis': {
    en: 'Inventory Value Analysis',
    fr: "Analyse de la valeur de l'inventaire",
    ar: 'تحليل قيمة المخزون'
  },
  'Total Inventory Value': {
    en: 'Total Inventory Value',
    fr: "Valeur totale de l'inventaire",
    ar: 'القيمة الإجمالية للمخزون'
  },
  'Low Stock Value at Risk': {
    en: 'Low Stock Value at Risk',
    fr: 'Valeur du stock faible à risque',
    ar: 'قيمة المخزون المنخفض في خطر'
  },
  'Potential Profit Margin': {
    en: 'Potential Profit Margin',
    fr: 'Marge bénéficiaire potentielle',
    ar: 'هامش الربح المحتمل'
  },
  'Average Item Value': {
    en: 'Average Item Value',
    fr: "Valeur moyenne de l'article",
    ar: 'متوسط قيمة العنصر'
  },
  'Good Stock': {
    en: 'Good Stock',
    fr: 'Stock correct',
    ar: 'مخزون جيد'
  },
  'Critical Stock': {
    en: 'Critical Stock',
    fr: 'Stock critique',
    ar: 'مخزون حرج'
  },
  'Items Needing Immediate Attention': {
    en: 'Items Needing Immediate Attention',
    fr: 'Articles nécessitant une attention immédiate',
    ar: 'عناصر تحتاج إلى اهتمام فوري'
  },
  'Most Valuable Items by Stock Value': {
    en: 'Most Valuable Items by Stock Value',
    fr: 'Articles les plus précieux par valeur de stock',
    ar: 'العناصر الأكثر قيمة حسب قيمة المخزون'
  },
  'Recent Inventory Movements': {
    en: 'Recent Inventory Movements',
    fr: "Mouvements d'inventaire récents",
    ar: 'تحركات المخزون الأخيرة'
  },
  Days: {
    en: 'Days',
    fr: 'Jours',
    ar: 'أيام'
  },
  Last: {
    en: 'Last',
    fr: 'Derniers',
    ar: 'آخر'
  },
  Stock: {
    en: 'Stock',
    fr: 'Stock',
    ar: 'مخزون'
  },
  Min: {
    en: 'Min',
    fr: 'Min',
    ar: 'الحد الأدنى'
  },
  Need: {
    en: 'Need',
    fr: 'Besoin',
    ar: 'يحتاج'
  },
  units: {
    en: 'units',
    fr: 'unités',
    ar: 'وحدات'
  },
  Critical: {
    en: 'Critical',
    fr: 'Critique',
    ar: 'حرج'
  },
  High: {
    en: 'High',
    fr: 'Élevé',
    ar: 'عالي'
  },
  Medium: {
    en: 'Medium',
    fr: 'Moyen',
    ar: 'متوسط'
  },
  SKU: {
    en: 'SKU',
    fr: 'SKU',
    ar: 'رمز المنتج'
  },
  Movement: {
    en: 'Movement',
    fr: 'Mouvement',
    ar: 'الحركة'
  },
  Quantity: {
    en: 'Quantity',
    fr: 'Quantité',
    ar: 'الكمية'
  },
  Date: {
    en: 'Date',
    fr: 'Date',
    ar: 'التاريخ'
  },
  Increase: {
    en: 'Increase',
    fr: 'Augmentation',
    ar: 'زيادة'
  },
  Decrease: {
    en: 'Decrease',
    fr: 'Diminution',
    ar: 'نقصان'
  },
  'Category Performance Analysis': {
    en: 'Category Performance Analysis',
    fr: 'Analyse des performances par catégorie',
    ar: 'تحليل أداء الفئات'
  },
  'Total Value': {
    en: 'Total Value',
    fr: 'Valeur totale',
    ar: 'القيمة الإجمالية'
  },
  'Avg Value/Item': {
    en: 'Avg Value/Item',
    fr: 'Valeur moy/Article',
    ar: 'متوسط القيمة/العنصر'
  },
  'Stock Health': {
    en: 'Stock Health',
    fr: 'Santé du stock',
    ar: 'صحة المخزون'
  },
  Healthy: {
    en: 'Healthy',
    fr: 'Sain',
    ar: 'صحي'
  },
  Good: {
    en: 'Good',
    fr: 'Bon',
    ar: 'جيد'
  },
  Warning: {
    en: 'Warning',
    fr: 'Attention',
    ar: 'تحذير'
  },
  'No Items': {
    en: 'No Items',
    fr: 'Aucun article',
    ar: 'لا توجد عناصر'
  },
  'Quick Insights': {
    en: 'Quick Insights',
    fr: 'Aperçus rapides',
    ar: 'رؤى سريعة'
  },
  'Recommended Actions': {
    en: 'Recommended Actions',
    fr: 'Actions recommandées',
    ar: 'الإجراءات الموصى بها'
  },
  high: {
    en: 'high',
    fr: 'élevé',
    ar: 'عالي'
  },
  medium: {
    en: 'medium',
    fr: 'moyen',
    ar: 'متوسط'
  },
  low: {
    en: 'low',
    fr: 'faible',
    ar: 'منخفض'
  },
  Impact: {
    en: 'Impact',
    fr: 'Impact',
    ar: 'التأثير'
  },
  'Most valuable item': {
    en: 'Most valuable item',
    fr: 'Article le plus précieux',
    ar: 'العنصر الأكثر قيمة'
  },
  at: {
    en: 'at',
    fr: 'à',
    ar: 'بـ'
  },
  'Average stock level': {
    en: 'Average stock level',
    fr: 'Niveau de stock moyen',
    ar: 'متوسط مستوى المخزون'
  },
  'units per item': {
    en: 'units per item',
    fr: 'unités par article',
    ar: 'وحدة لكل عنصر'
  },
  'of items are below minimum stock level': {
    en: 'of items are below minimum stock level',
    fr: 'des articles sont en dessous du niveau de stock minimum',
    ar: 'من العناصر أقل من الحد الأدنى لمستوى المخزون'
  },
  'Current inventory profit margin': {
    en: 'Current inventory profit margin',
    fr: "Marge bénéficiaire actuelle de l'inventaire",
    ar: 'هامش ربح المخزون الحالي'
  },
  'Urgent Restocking Required': {
    en: 'Urgent Restocking Required',
    fr: 'Réapprovisionnement urgent requis',
    ar: 'مطلوب إعادة تخزين عاجلة'
  },
  'items are completely out of stock and need immediate restocking.': {
    en: 'items are completely out of stock and need immediate restocking.',
    fr: 'articles sont complètement en rupture de stock et nécessitent un réapprovisionnement immédiat.',
    ar: 'عناصر نفدت تماماً من المخزون وتحتاج إلى إعادة تخزين فورية.'
  },
  'Potential lost sales and customer dissatisfaction': {
    en: 'Potential lost sales and customer dissatisfaction',
    fr: 'Perte potentielle de ventes et insatisfaction client',
    ar: 'مبيعات محتملة مفقودة وعدم رضا العملاء'
  },
  'Plan Inventory Replenishment': {
    en: 'Plan Inventory Replenishment',
    fr: "Planifier le réapprovisionnement de l'inventaire",
    ar: 'خطط لتجديد المخزون'
  },
  'items are below minimum stock levels and should be reordered soon.': {
    en: 'items are below minimum stock levels and should be reordered soon.',
    fr: 'articles sont en dessous des niveaux de stock minimum et devraient être récommandés bientôt.',
    ar: 'عناصر أقل من مستويات المخزون الدنيا ويجب إعادة طلبها قريباً.'
  },
  'Prevent stockouts and maintain service levels': {
    en: 'Prevent stockouts and maintain service levels',
    fr: 'Prévenir les ruptures de stock et maintenir les niveaux de service',
    ar: 'منع نفاد المخزون والحفاظ على مستويات الخدمة'
  },
  'Optimize Low-Value Inventory': {
    en: 'Optimize Low-Value Inventory',
    fr: "Optimiser l'inventaire de faible valeur",
    ar: 'تحسين المخزون منخفض القيمة'
  },
  'items have very low total value. Consider reviewing these items.': {
    en: 'items have very low total value. Consider reviewing these items.',
    fr: 'articles ont une valeur totale très faible. Envisagez de réviser ces articles.',
    ar: 'عناصر لها قيمة إجمالية منخفضة جداً. فكر في مراجعة هذه العناصر.'
  },
  'Free up storage space and reduce carrying costs': {
    en: 'Free up storage space and reduce carrying costs',
    fr: "Libérer l'espace de stockage et réduire les coûts de possession",
    ar: 'تحرير مساحة التخزين وتقليل تكاليف الحمل'
  },
  'Click to view item in inventory': {
    en: 'Click to view item in inventory',
    fr: "Cliquez pour voir l'article dans l'inventaire",
    ar: 'انقر لعرض العنصر في المخزون'
  },
  'You are about to view the full item in inventory': {
    en: 'You are about to view the full item in inventory',
    fr: "Vous êtes sur le point de voir l'article complet dans l'inventaire",
    ar: 'أنت على وشك عرض العنصر الكامل في المخزون'
  },
  Continue: {
    en: 'Continue',
    fr: 'Continuer',
    ar: 'متابعة'
  },
  'Transaction Quantity': {
    en: 'Transaction Quantity',
    fr: 'Quantité de transaction',
    ar: 'كمية المعاملة'
  },
  'Transaction Id:': {
    en: 'Transaction Id:',
    fr: 'ID de transaction :',
    ar: 'معرّف المعاملة:'
  },
  'Unnamed Transaction': {
    en: 'Unnamed Transaction',
    fr: 'Transaction sans nom',
    ar: 'معاملة بدون اسم'
  },
  'Inventory Operation': {
    en: 'Inventory Operation',
    fr: "Opération d'inventaire",
    ar: 'عملية المخزون'
  },
  'Return to Inventory': {
    en: 'Return to Inventory',
    fr: "Retour à l'inventaire",
    ar: 'إرجاع إلى المخزون'
  },
  'Folder Transfer': {
    en: 'Folder Transfer',
    fr: 'Transfert de dossier',
    ar: 'نقل المجلد'
  },
  'Transfer Out': {
    en: 'Transfer Out',
    fr: 'Transfert sortant',
    ar: 'نقل خارج'
  },
  'Transfer In': {
    en: 'Transfer In',
    fr: 'Transfert entrant',
    ar: 'نقل داخل'
  },
  Active: {
    en: 'Active',
    fr: 'Actif',
    ar: 'نشط'
  },
  Returned: {
    en: 'Returned',
    fr: 'Retourné',
    ar: 'مُعاد'
  },
  Transferred: {
    en: 'Transferred',
    fr: 'Transféré',
    ar: 'مُحوَّل'
  },
  Sent: {
    en: 'Sent',
    fr: 'Envoyé',
    ar: 'مُرسل'
  },
  Received: {
    en: 'Received',
    fr: 'Reçu',
    ar: 'مُستلم'
  },
  'Error processing reason': {
    en: 'Error processing reason',
    fr: 'Erreur lors du traitement de la raison',
    ar: 'خطأ في معالجة السبب'
  },
  'Unknown Folder': {
    en: 'Unknown Folder',
    fr: 'Dossier inconnu',
    ar: 'مجلد غير معروف'
  },
  'Transfer Route': {
    en: 'Transfer Route',
    fr: 'Route de transfert',
    ar: 'مسار النقل'
  },
  added: {
    en: 'added',
    fr: 'ajouté',
    ar: 'مُضاف'
  },
  removed: {
    en: 'removed',
    fr: 'supprimé',
    ar: 'مُزال'
  },
  Reason: {
    en: 'Reason',
    fr: 'Raison',
    ar: 'السبب'
  },
  'No reason provided': {
    en: 'No reason provided',
    fr: 'Aucune raison fournie',
    ar: 'لم يتم تقديم سبب'
  },
  'Created by': {
    en: 'Created by',
    fr: 'Créé par',
    ar: 'أنشأ بواسطة'
  },
  'Move Item to Folder': {
    en: 'Move Item to Folder',
    fr: "Déplacer l'article vers le dossier",
    ar: 'نقل العنصر إلى المجلد'
  },
  'Available Quantity': {
    en: 'Available Quantity',
    fr: 'Quantité disponible',
    ar: 'الكمية المتاحة'
  },
  'Select Destination Folder': {
    en: 'Select Destination Folder',
    fr: 'Sélectionner le dossier de destination',
    ar: 'اختر مجلد الوجهة'
  },
  'Quantity to Move': {
    en: 'Quantity to Move',
    fr: 'Quantité à déplacer',
    ar: 'الكمية المراد نقلها'
  },
  'Move Reason': {
    en: 'Move Reason',
    fr: 'Raison du déplacement',
    ar: 'سبب النقل'
  },
  'Additional Notes': {
    en: 'Additional Notes',
    fr: 'Notes supplémentaires',
    ar: 'ملاحظات إضافية'
  },
  'Move Item': {
    en: 'Move Item',
    fr: "Déplacer l'article",
    ar: 'نقل العنصر'
  },
  'Cashier Move': {
    en: 'Cashier Move',
    fr: 'Mouvement de caisse',
    ar: 'حركة الصندوق'
  },
  'Scan or search item by name/SKU': {
    en: 'Scan or search item by name/SKU',
    fr: 'Scanner ou rechercher un article par nom/SKU',
    ar: 'مسح أو بحث عن العنصر بالاسم/SKU'
  },
  'Scan or select an item to begin.': {
    en: 'Scan or select an item to begin.',
    fr: 'Scannez ou sélectionnez un article pour commencer.',
    ar: 'امسح أو اختر عنصرًا للبدء.'
  },
  'Optional notes about the move': {
    en: 'Optional notes about the move',
    fr: 'Notes facultatives sur le déplacement',
    ar: 'ملاحظات اختيارية حول النقل'
  },
  'Inventory Transfer Facture': {
    en: 'Inventory Transfer Facture',
    fr: "Facture de transfert d'inventaire",
    ar: 'فاتورة نقل المخزون'
  },
  'Item Movement Summary': {
    en: 'Item Movement Summary',
    fr: 'Résumé du mouvement des articles',
    ar: 'ملخص حركة العناصر'
  },
  'Transfer ID': {
    en: 'Transfer ID',
    fr: 'ID de transfert',
    ar: 'معرف النقل'
  },
  'Transfer Details': {
    en: 'Transfer Details',
    fr: 'Détails du transfert',
    ar: 'تفاصيل النقل'
  },
  'Destination Folder': {
    en: 'Destination Folder',
    fr: 'Dossier de destination',
    ar: 'المجلد الوجهة'
  },
  'Moved Items': {
    en: 'Moved Items',
    fr: 'Articles déplacés',
    ar: 'العناصر المنقولة'
  },
  'Items Moved': {
    en: 'Items Moved',
    fr: 'Articles déplacés',
    ar: 'العناصر المنقولة'
  },
  'Total Quantity': {
    en: 'Total Quantity',
    fr: 'Quantité totale',
    ar: 'الكمية الإجمالية'
  },
  'Print Facture': {
    en: 'Print Facture',
    fr: 'Imprimer la facture',
    ar: 'طباعة الفاتورة'
  },
  Brand: {
    en: 'Brand',
    fr: 'Marque',
    ar: 'العلامة التجارية'
  },
  'Product Found': {
    en: 'Product Found',
    fr: 'Produit trouvé',
    ar: 'تم العثور على المنتج'
  },
  'Would you like to auto-fill the form with this product information?': {
    en: 'Would you like to auto-fill the form with this product information?',
    fr: 'Voulez-vous remplir automatiquement le formulaire avec ces informations produit?',
    ar: 'هل تريد ملء النموذج تلقائيًا بمعلومات هذا المنتج؟'
  },
  'No, Fill Manually': {
    en: 'No, Fill Manually',
    fr: 'Non, remplir manuellement',
    ar: 'لا، املأ يدوياً'
  },
  'Yes, Auto-Fill': {
    en: 'Yes, Auto-Fill',
    fr: 'Oui, remplir automatiquement',
    ar: 'نعم، املأ تلقائياً'
  },
  'Product image will be set as URL:': {
    en: 'Product image will be set as URL:',
    fr: "L'image du produit sera définie comme URL :",
    ar: 'سيتم تعيين صورة المنتج كرابط:'
  },
  Accounts: {
    en: 'Accounts',
    fr: 'Comptes',
    ar: 'الحسابات'
  },
  'First Name': {
    en: 'First Name',
    fr: 'Prénom',
    ar: 'الاسم الأول'
  },
  'Last Name': {
    en: 'Last Name',
    fr: 'Nom de famille',
    ar: 'اسم العائلة'
  },
  Username: {
    en: 'Username',
    fr: "Nom d'utilisateur",
    ar: 'اسم المستخدم'
  },
  Email: {
    en: 'Email',
    fr: 'Email',
    ar: 'البريد الإلكتروني'
  },
  Password: {
    en: 'Password',
    fr: 'Mot de passe',
    ar: 'كلمة المرور'
  },
  Role: {
    en: 'Role',
    fr: 'Rôle',
    ar: 'الدور'
  },
  'Create User': {
    en: 'Create User',
    fr: 'Créer un utilisateur',
    ar: 'إنشاء مستخدم'
  },
  'User created successfully': {
    en: 'User created successfully',
    fr: 'Utilisateur créé avec succès',
    ar: 'تم إنشاء المستخدم بنجاح'
  },
  Users: {
    en: 'Users',
    fr: 'Utilisateurs',
    ar: 'المستخدمون'
  },
  Owner: {
    en: 'Owner',
    fr: 'Propriétaire',
    ar: 'مالك'
  },
  Admin: {
    en: 'Admin',
    fr: 'Admin',
    ar: 'مشرف'
  },
  Cashier: {
    en: 'Cashier',
    fr: 'Caissier',
    ar: 'أمين الصندوق'
  },
  'Purchase Orders': {
    en: 'Purchase Orders',
    fr: 'Bons de commande',
    ar: 'أوامر الشراء'
  },
  'New Purchase Order': {
    en: 'New Purchase Order',
    fr: 'Nouveau bon de commande',
    ar: 'أمر شراء جديد'
  },
  Pending: {
    en: 'Pending',
    fr: 'En attente',
    ar: 'قيد الانتظار'
  },
  'No pending purchase orders': {
    en: 'No pending purchase orders',
    fr: 'Aucun bon de commande en attente',
    ar: 'لا توجد أوامر شراء قيد الانتظار'
  },
  'No received purchase orders': {
    en: 'No received purchase orders',
    fr: 'Aucun bon de commande reçu',
    ar: 'لا توجد أوامر شراء مستلمة'
  },
  'Supplier Name': {
    en: 'Supplier Name',
    fr: 'Nom du fournisseur',
    ar: 'اسم المورد'
  },
  'Supplier Email': {
    en: 'Supplier Email',
    fr: 'Email du fournisseur',
    ar: 'البريد الإلكتروني للمورد'
  },
  'Supplier Phone': {
    en: 'Supplier Phone',
    fr: 'Téléphone du fournisseur',
    ar: 'هاتف المورد'
  },
  'Line Items': {
    en: 'Line Items',
    fr: 'Articles de la commande',
    ar: 'عناصر السطر'
  },
  'Add existing item': {
    en: 'Add existing item',
    fr: 'Ajouter un article existant',
    ar: 'إضافة عنصر موجود'
  },
  'Add new item': {
    en: 'Add new item',
    fr: 'Ajouter un nouvel article',
    ar: 'إضافة عنصر جديد'
  },
  'Item (new — will be created)': {
    en: 'Item (new — will be created)',
    fr: 'Article (nouveau — sera créé)',
    ar: 'عنصر (جديد — سيتم إنشاؤه)'
  },
  Clear: {
    en: 'Clear',
    fr: 'Effacer',
    ar: 'مسح'
  },
  Qty: {
    en: 'Qty',
    fr: 'Qté',
    ar: 'الكمية'
  },
  Buy: {
    en: 'Buy',
    fr: 'Achat',
    ar: 'شراء'
  },
  Sell: {
    en: 'Sell',
    fr: 'Vente',
    ar: 'بيع'
  },
  Name: {
    en: 'Name',
    fr: 'Nom',
    ar: 'الاسم'
  },
  'SKU (optional)': {
    en: 'SKU (optional)',
    fr: 'SKU (optionnel)',
    ar: 'رمز التخزين (اختياري)'
  },
  'Enter barcode to auto-fill product details': {
    en: 'Enter barcode to auto-fill product details',
    fr: 'Entrez le code-barres pour remplir automatiquement les détails du produit',
    ar: 'أدخل الباركود لملء تفاصيل المنتج تلقائيًا'
  },
  'QR Code (optional)': {
    en: 'QR Code (optional)',
    fr: 'QR Code (optionnel)',
    ar: 'رمز QR (اختياري)'
  },
  'Quantity (this order)': {
    en: 'Quantity (this order)',
    fr: 'Quantité (cette commande)',
    ar: 'الكمية (لهذا الطلب)'
  },
  'Alert on Low': {
    en: 'Alert on Low',
    fr: 'Alerte en cas de bas niveau',
    ar: 'تنبيه عند الانخفاض'
  },
  'Enter and press enter to add tags': {
    en: 'Enter and press enter to add tags',
    fr: 'Entrez et appuyez sur Entrée pour ajouter des tags',
    ar: 'أدخل واضغط إدخال لإضافة وسوم'
  },
  'Barcode Product Found': {
    en: 'Barcode Product Found',
    fr: 'Produit trouvé par code-barres',
    ar: 'تم العثور على منتج بالباركود'
  },
  'Keep as New': {
    en: 'Keep as New',
    fr: 'Garder comme nouveau',
    ar: 'الاحتفاظ كعنصر جديد'
  },
  'Use Existing': {
    en: 'Use Existing',
    fr: "Utiliser l'existant",
    ar: 'استخدام الموجود'
  },
  'Failed to finalize': {
    en: 'Failed to finalize',
    fr: 'Échec de la finalisation',
    ar: 'فشل الإنهاء'
  },
  'Delete Purchase Order': {
    en: 'Delete purchase order',
    fr: 'Supprimer le bon de commande',
    ar: 'حذف أمر الشراء'
  },
  'This cannot be undone': {
    en: 'This cannot be undone.',
    fr: 'Cette action est irréversible.',
    ar: 'لا يمكن التراجع عن هذا.'
  },
  'Purchase order deleted': {
    en: 'Purchase order deleted',
    fr: 'Bon de commande supprimé',
    ar: 'تم حذف أمر الشراء'
  },
  'Failed to delete purchase order': {
    en: 'Failed to delete purchase order',
    fr: 'Échec de la suppression du bon de commande',
    ar: 'فشل حذف أمر الشراء'
  },
  'Custom Fields must be valid JSON': {
    en: 'Custom Fields must be valid JSON',
    fr: 'Les champs personnalisés doivent être au format JSON valide',
    ar: 'يجب أن تكون الحقول المخصصة JSON صالحًا'
  },
  'Item prepared; will be created on submit': {
    en: 'Item prepared; will be created on submit',
    fr: 'Article préparé; sera créé lors de la soumission',
    ar: 'تم إعداد العنصر؛ سيتم إنشاؤه عند الإرسال'
  },
  'Failed to prepare item': {
    en: 'Failed to prepare item',
    fr: "Échec de la préparation de l'article",
    ar: 'فشل في إعداد العنصر'
  },
  'Existing item will be updated (buying price recalculated) on submit': {
    en: 'Existing item will be updated (buying price recalculated) on submit',
    fr: "L'article existant sera mis à jour (prix d'achat recalculé) lors de la soumission",
    ar: 'سيتم تحديث العنصر الموجود (إعادة حساب سعر الشراء) عند الإرسال'
  },
  'New item will be created on submit': {
    en: 'New item will be created on submit',
    fr: 'Un nouvel article sera créé lors de la soumission',
    ar: 'سيتم إنشاء عنصر جديد عند الإرسال'
  },
  'Product not found for this barcode': {
    en: 'Product not found for this barcode',
    fr: 'Produit introuvable pour ce code-barres',
    ar: 'لم يتم العثور على منتج لهذا الباركود'
  },
  'Failed to lookup barcode': {
    en: 'Failed to lookup barcode',
    fr: 'Échec de la recherche du code-barres',
    ar: 'فشل البحث عن الباركود'
  },
  'Product details auto-filled': {
    en: 'Product details auto-filled',
    fr: 'Détails du produit remplis automatiquement',
    ar: 'تم ملء تفاصيل المنتج تلقائيًا'
  },
  'Purchase order created': {
    en: 'Purchase order created',
    fr: 'Bon de commande créé',
    ar: 'تم إنشاء أمر الشراء'
  },
  'Failed to create purchase order': {
    en: 'Failed to create purchase order',
    fr: 'Échec de la création du bon de commande',
    ar: 'فشل إنشاء أمر الشراء'
  },
  'Purchase order finalized': {
    en: 'Purchase order finalized',
    fr: 'Bon de commande finalisé',
    ar: 'تم إنهاء أمر الشراء'
  },
  Finalize: {
    en: 'Finalize',
    fr: 'Finaliser',
    ar: 'إنهاء'
  },
  'Unknown supplier': {
    en: 'Unknown supplier',
    fr: 'Fournisseur inconnu',
    ar: 'مورد غير معروف'
  },
  lines: {
    en: 'lines',
    fr: 'lignes',
    ar: 'أسطر'
  },
  qty: {
    en: 'qty',
    fr: 'qté',
    ar: 'كمية'
  },
  'Purchase Order': {
    en: 'Purchase Order',
    fr: 'Bon de commande',
    ar: 'أمر شراء'
  },
  Supplier: {
    en: 'Supplier',
    fr: 'Fournisseur',
    ar: 'المورد'
  },
  Status: {
    en: 'Status',
    fr: 'Statut',
    ar: 'الحالة'
  },
  'Line Total': {
    en: 'Line Total',
    fr: 'Total ligne',
    ar: 'الإجمالي الفرعي'
  },
  Total: {
    en: 'Total',
    fr: 'Total',
    ar: 'الإجمالي'
  },
  'Generate PDF': {
    en: 'Generate PDF',
    fr: 'Générer PDF',
    ar: 'إنشاء PDF'
  },
  Close: {
    en: 'Close',
    fr: 'Fermer',
    ar: 'إغلاق'
  },
  'Generate PO': {
    en: 'Generate PO',
    fr: 'Générer BC',
    ar: 'إنشاء أمر شراء'
  },
  Lines: {
    en: 'Lines',
    fr: 'Lignes',
    ar: 'الأسطر'
  },
  'Existing Item': {
    en: 'Existing Item',
    fr: 'Article existant',
    ar: 'عنصر موجود'
  },
  new: {
    en: 'new',
    fr: 'nouveau',
    ar: 'جديد'
  },
  'Add Existing Item': {
    en: 'Add Existing Item',
    fr: 'Ajouter un article existant',
    ar: 'إضافة عنصر موجود'
  },
  Add: {
    en: 'Add',
    fr: 'Ajouter',
    ar: 'إضافة'
  },
  'Add New Item (Snapshot)': {
    en: 'Add New Item (Snapshot)',
    fr: 'Ajouter un nouvel article (instantané)',
    ar: 'إضافة عنصر جديد (لقطة)'
  },
  'Name is required': {
    en: 'Name is required',
    fr: 'Le nom est requis',
    ar: 'الاسم مطلوب'
  },
  'Select an item': {
    en: 'Select an item',
    fr: 'Sélectionnez un article',
    ar: 'اختر عنصراً'
  },
  'Purchase order updated': {
    en: 'Purchase order updated',
    fr: 'Bon de commande mis à jour',
    ar: 'تم تحديث أمر الشراء'
  },
  'Failed to save changes': {
    en: 'Failed to save changes',
    fr: "Échec de l'enregistrement des modifications",
    ar: 'فشل حفظ التغييرات'
  },
  'Failed to load purchase order': {
    en: 'Failed to load purchase order',
    fr: 'Échec du chargement du bon de commande',
    ar: 'فشل تحميل أمر الشراء'
  },
  // Added for Cards/Rows view and tables
  Cards: {
    en: 'Cards',
    fr: 'Cartes',
    ar: 'بطاقات'
  },
  Rows: {
    en: 'Rows',
    fr: 'Lignes',
    ar: 'صفوف'
  },
  'Items by Tag': {
    en: 'Items by Tag',
    fr: 'Articles par étiquette',
    ar: 'عناصر حسب الوسم'
  },
  'No items': {
    en: 'No items',
    fr: 'Aucun article',
    ar: 'لا توجد عناصر'
  },
  'No folders': {
    en: 'No folders',
    fr: 'Aucun dossier',
    ar: 'لا توجد مجلدات'
  },
  'No categories': {
    en: 'No categories',
    fr: 'Aucune catégorie',
    ar: 'لا توجد فئات'
  },
  Parent: {
    en: 'Parent',
    fr: 'Parent',
    ar: 'الأصل'
  },
  Tag: {
    en: 'Tag',
    fr: 'Étiquette',
    ar: 'وسم'
  },
  ID: {
    en: 'ID',
    fr: 'ID',
    ar: 'المعرف'
  },
  'No transactions': {
    en: 'No transactions',
    fr: 'Aucune transaction',
    ar: 'لا توجد معاملات'
  },
  'Generate Facture': {
    en: 'Generate Facture',
    fr: 'Générer la facture',
    ar: 'إنشاء الفاتورة'
  },
  Deleted: {
    en: 'Deleted',
    fr: 'Supprimé',
    ar: 'محذوف'
  },
  'Transfer Destination': {
    en: 'Transfer Destination',
    fr: 'Destination du transfert',
    ar: 'وجهة التحويل'
  },
  // Added for row/card action dialogs and tree selectors
  'Confirm Delete': {
    en: 'Confirm Delete',
    fr: 'Confirmer la suppression',
    ar: 'تأكيد الحذف'
  },
  'Are you sure you want to delete': {
    en: 'Are you sure you want to delete',
    fr: 'Êtes-vous sûr de vouloir supprimer',
    ar: 'هل أنت متأكد أنك تريد الحذف'
  },
  'Delete Forever': {
    en: 'Delete Forever',
    fr: 'Supprimer définitivement',
    ar: 'حذف نهائي'
  },
  'Root Level (No Parent)': {
    en: 'Root Level (No Parent)',
    fr: 'Niveau racine (sans parent)',
    ar: 'المستوى الجذر (بدون أب)'
  },
  Root: {
    en: 'Root',
    fr: 'Racine',
    ar: 'الجذر'
  },
  Photo: {
    en: 'Photo',
    fr: 'Photo',
    ar: 'صورة'
  },
  'Generate Barcode': {
    en: 'Generate Barcode',
    fr: 'Générer un code-barres',
    ar: 'توليد باركود'
  },
  'Search folders': {
    en: 'Search folders',
    fr: 'Rechercher des dossiers',
    ar: 'البحث في المجلدات'
  },
  // Pricing labels used in ItemMover
  Price: {
    en: 'Price',
    fr: 'Prix',
    ar: 'السعر'
  },
  'Return Transaction': {
    en: 'Return Transaction',
    fr: 'Retour de la transaction',
    ar: 'إرجاع المعاملة'
  },
  Transaction: {
    en: 'Transaction',
    fr: 'Transaction',
    ar: 'المعاملة'
  },
  'Return reason': {
    en: 'Return reason',
    fr: 'Raison du retour',
    ar: 'سبب الإرجاع'
  },
  'Optional notes about the return': {
    en: 'Optional notes about the return',
    fr: 'Notes facultatives sur le retour',
    ar: 'ملاحظات اختيارية حول الإرجاع'
  },
  'This will create return movements for all items in the transaction': {
    en: 'This will create return movements for all items in the transaction',
    fr: 'Cela créera des mouvements de retour pour tous les articles de la transaction',
    ar: 'سيؤدي ذلك إلى إنشاء حركات إرجاع لجميع العناصر في المعاملة'
  },
  'Sub Folders': {
    en: 'Sub Folders',
    fr: 'Sous-dossiers',
    ar: 'المجلدات الفرعية'
  },
  'Unit Price': {
    en: 'Unit Price',
    fr: 'Prix unitaire',
    ar: 'سعر الوحدة'
  },
  // Audit Log Viewer translations
  'Activity Events': {
    en: 'Activity Events',
    fr: 'Événements d’activité',
    ar: 'أحداث النشاط'
  },
  Reload: {
    en: 'Reload',
    fr: 'Recharger',
    ar: 'إعادة التحميل'
  },
  'Loading…': {
    en: 'Loading…',
    fr: 'Chargement…',
    ar: 'جارٍ التحميل…'
  },
  User: {
    en: 'User',
    fr: 'Utilisateur',
    ar: 'المستخدم'
  },
  'Item Name': {
    en: 'Item Name',
    fr: 'Nom de l’article',
    ar: 'اسم المنتج'
  },
  'Folder Name': {
    en: 'Folder Name',
    fr: 'Nom du dossier',
    ar: 'اسم المجلد'
  },
  'Category Name': {
    en: 'Category Name',
    fr: 'Nom de la catégorie',
    ar: 'اسم الفئة'
  },
  From: {
    en: 'From',
    fr: 'De',
    ar: 'من'
  },
  To: {
    en: 'To',
    fr: 'À',
    ar: 'إلى'
  },
  Action: {
    en: 'Action',
    fr: 'Action',
    ar: 'الإجراء'
  },
  'Filter by username': {
    en: 'Filter by username',
    fr: 'Filtrer par nom d’utilisateur',
    ar: 'تصفية حسب اسم المستخدم'
  },
  'Filter by item name': {
    en: 'Filter by item name',
    fr: 'Filtrer par nom d’article',
    ar: 'تصفية حسب اسم المنتج'
  },
  'Filter by folder name': {
    en: 'Filter by folder name',
    fr: 'Filtrer par nom de dossier',
    ar: 'تصفية حسب اسم المجلد'
  },
  'Filter by category name': {
    en: 'Filter by category name',
    fr: 'Filtrer par nom de catégorie',
    ar: 'تصفية حسب اسم الفئة'
  },
  'All Actions': {
    en: 'All Actions',
    fr: 'Toutes les actions',
    ar: 'كل الإجراءات'
  },
  'Adjust Quantity': {
    en: 'Adjust Quantity',
    fr: 'Ajuster la quantité',
    ar: 'تعديل الكمية'
  },
  'Move to Folder': {
    en: 'Move to Folder',
    fr: 'Déplacer vers le dossier',
    ar: 'نقل إلى مجلد'
  },
  'Update Item': {
    en: 'Update Item',
    fr: 'Mettre à jour l’article',
    ar: 'تحديث المنتج'
  },
  'Create Item': {
    en: 'Create Item',
    fr: 'Créer un article',
    ar: 'إنشاء منتج'
  },
  'Delete Item': {
    en: 'Delete Item',
    fr: 'Supprimer l’article',
    ar: 'حذف المنتج'
  },
  'Update Categories': {
    en: 'Update Categories',
    fr: 'Mettre à jour les catégories',
    ar: 'تحديث الفئات'
  },
  'Clear Filters': {
    en: 'Clear Filters',
    fr: 'Effacer les filtres',
    ar: 'مسح عوامل التصفية'
  },
  'Loading events…': {
    en: 'Loading events…',
    fr: 'Chargement des événements…',
    ar: 'جارٍ تحميل الأحداث…'
  },
  'No events match your filters.': {
    en: 'No events match your filters.',
    fr: 'Aucun événement ne correspond à vos filtres.',
    ar: 'لا توجد أحداث تطابق عوامل التصفية.'
  },
  'No events found.': {
    en: 'No events found.',
    fr: 'Aucun événement trouvé.',
    ar: 'لا توجد أحداث.'
  },
  Time: {
    en: 'Time',
    fr: 'Heure',
    ar: 'الوقت'
  },
  Item: {
    en: 'Item',
    fr: 'Article',
    ar: 'المنتج'
  },
  Folder: {
    en: 'Folder',
    fr: 'Dossier',
    ar: 'المجلد'
  },
  Category: {
    en: 'Category',
    fr: 'Catégorie',
    ar: 'الفئة'
  },
  Delta: {
    en: 'Delta',
    fr: 'Écart',
    ar: 'التغير'
  },
  'Prev Qty': {
    en: 'Prev Qty',
    fr: 'Qté préc.',
    ar: 'الكمية السابقة'
  },
  'New Qty': {
    en: 'New Qty',
    fr: 'Nouvelle qté',
    ar: 'الكمية الجديدة'
  },
  Summary: {
    en: 'Summary',
    fr: 'Résumé',
    ar: 'الملخص'
  },
  Previous: {
    en: 'Previous',
    fr: 'Précédent',
    ar: 'السابق'
  },
  Next: {
    en: 'Next',
    fr: 'Suivant',
    ar: 'التالي'
  },
  Page: {
    en: 'Page',
    fr: 'Page',
    ar: 'صفحة'
  },
  of: {
    en: 'of',
    fr: 'sur',
    ar: 'من'
  },
  Showing: {
    en: 'Showing',
    fr: 'Affichage',
    ar: 'عرض'
  },
  events: {
    en: 'events',
    fr: 'événements',
    ar: 'أحداث'
  },
  'Adjust Qty': {
    en: 'Adjust Qty',
    fr: 'Ajuster qté',
    ar: 'تعديل الكمية'
  },
  Update: {
    en: 'Update',
    fr: 'Mettre à jour',
    ar: 'تحديث'
  },
  Create: {
    en: 'Create',
    fr: 'Créer',
    ar: 'إنشاء'
  },
  'Update Cat': {
    en: 'Update Cat',
    fr: 'Mettre à jour cat.',
    ar: 'تحديث الفئة'
  },
  'Failed to load events': {
    en: 'Failed to load events',
    fr: 'Échec du chargement des événements',
    ar: 'فشل تحميل الأحداث'
  },
  'Move Items to Folder': {
    en: 'Move Items to Folder',
    fr: 'Déplacer les articles vers le dossier',
    ar: 'نقل العناصر إلى المجلد'
  },
  'Move Items': {
    en: 'Move Items',
    fr: 'Déplacer',
    ar: 'نقل العناصر'
  },
  'Create Folder': {
    en: 'Create Folder',
    fr: 'Créer un dossier',
    ar: 'إنشاء مجلد'
  },
  'Update Folder': {
    en: 'Update Folder',
    fr: 'Mettre à jour le dossier',
    ar: 'تحديث المجلد'
  },
  'Delete Folder': {
    en: 'Delete Folder',
    fr: 'Supprimer le dossier',
    ar: 'حذف المجلد'
  },
  'Move Folder Parent': {
    en: 'Move Folder Parent',
    fr: 'Déplacer parent du dossier',
    ar: 'نقل المجلد الأصل'
  },
  'Move Parent': {
    en: 'Move Parent',
    fr: 'Dépl. parent',
    ar: 'نقل الأصل'
  },
  'Create Category': {
    en: 'Create Category',
    fr: 'Créer une catégorie',
    ar: 'إنشاء فئة'
  },
  'Update Category': {
    en: 'Update Category',
    fr: 'Mettre à jour la catégorie',
    ar: 'تحديث الفئة'
  },
  'Delete Category': {
    en: 'Delete Category',
    fr: 'Supprimer la catégorie',
    ar: 'حذف الفئة'
  },
  'Move Category Parent': {
    en: 'Move Category Parent',
    fr: 'Déplacer parent de la catégorie',
    ar: 'نقل الفئة الأصل'
  },
  'Finalize Purchase Order': {
    en: 'Finalize Purchase Order',
    fr: 'Finaliser le bon de commande',
    ar: 'إنهاء أمر الشراء'
  },
  'Finalize PO': {
    en: 'Finalize PO',
    fr: 'Finaliser BC',
    ar: 'إنهاء أمر الشراء'
  },
  'Item Name is required': {
    en: 'Item Name is required',
    fr: "Le nom de l'article est requis",
    ar: 'اسم العنصر مطلوب'
  },
  'Quantity must be a valid number': {
    en: 'Quantity must be a valid number',
    fr: 'La quantité doit être un nombre valide',
    ar: 'يجب أن تكون الكمية رقمًا صالحًا'
  },
  'Selling Price must be a valid number': {
    en: 'Selling Price must be a valid number',
    fr: 'Le prix de vente doit être un nombre valide',
    ar: 'يجب أن يكون سعر البيع رقمًا صالحًا'
  },
  'Buying Price must be a valid number': {
    en: 'Buying Price must be a valid number',
    fr: "Le prix d'achat doit être un nombre valide",
    ar: 'يجب أن يكون سعر الشراء رقمًا صالحًا'
  },
  'Minimum Level must be a valid number': {
    en: 'Minimum Level must be a valid number',
    fr: 'Le niveau minimum doit être un nombre valide',
    ar: 'يجب أن يكون الحد الأدنى رقمًا صالحًا'
  },
  'Please fix the errors above before saving': {
    en: 'Please fix the errors above before saving',
    fr: 'Veuillez corriger les erreurs ci-dessus avant de sauvegarder',
    ar: 'يرجى إصلاح الأخطاء أعلاه قبل الحفظ'
  },
  'max 2': {
    en: 'max 2',
    fr: 'max 2',
    ar: 'الحد الأقصى 2'
  },
  Key: {
    en: 'Key',
    fr: 'Clé',
    ar: 'المفتاح'
  },
  Value: {
    en: 'Value',
    fr: 'Valeur',
    ar: 'القيمة'
  },
  'Add Field': {
    en: 'Add Field',
    fr: 'Ajouter un champ',
    ar: 'إضافة حقل'
  },
  'A category with this name already exists.': {
    en: 'A category with this name already exists.',
    fr: 'Une catégorie avec ce nom existe déjà.',
    ar: 'توجد فئة بهذا الاسم بالفعل.'
  },
  'Selected parent category does not exist.': {
    en: 'Selected parent category does not exist.',
    fr: "La catégorie parente sélectionnée n'existe pas.",
    ar: 'الفئة الأصل المحددة غير موجودة.'
  },
  'One or more selected items do not exist.': {
    en: 'One or more selected items do not exist.',
    fr: "Un ou plusieurs articles sélectionnés n'existent pas.",
    ar: 'عنصر واحد أو أكثر من العناصر المحددة غير موجود.'
  },
  'Server error. Please try again later.': {
    en: 'Server error. Please try again later.',
    fr: 'Erreur serveur. Veuillez réessayer plus tard.',
    ar: 'خطأ في الخادم. يرجى المحاولة مرة أخرى لاحقًا.'
  },
  'Network error. Please check your connection.': {
    en: 'Network error. Please check your connection.',
    fr: 'Erreur réseau. Veuillez vérifier votre connexion.',
    ar: 'خطأ في الشبكة. يرجى التحقق من اتصالك.'
  },
  'Stock In Value vs Stock Out Value': {
    en: 'Stock In Value vs Stock Out Value',
    fr: 'Valeur entrante vs valeur sortante du stock',
    ar: 'قيمة المخزون الداخل مقابل قيمة المخزون الخارج'
  },
  'Compare inventory value coming in and going out.': {
    en: 'Compare inventory value coming in and going out.',
    fr: 'Comparez la valeur du stock entrant et sortant.',
    ar: 'قارن قيمة المخزون الداخل والخارج.'
  },
  Bars: {
    en: 'Bars',
    fr: 'Barres',
    ar: 'الأعمدة'
  },
  Line: {
    en: 'Line',
    fr: 'Ligne',
    ar: 'خط'
  },
  Day: {
    en: 'Day',
    fr: 'Jour',
    ar: 'يوم'
  },
  Month: {
    en: 'Month',
    fr: 'Mois',
    ar: 'شهر'
  },
  Year: {
    en: 'Year',
    fr: 'Année',
    ar: 'سنة'
  },
  'Loading graph data... This may take a few seconds while we analyze your inventory data.':
    {
      en: 'Loading graph data... This may take a few seconds while we analyze your inventory data.',
      fr: 'Chargement des données du graphique... Cela peut prendre quelques secondes pendant que nous analysons vos données d’inventaire.',
      ar: 'جارٍ تحميل بيانات الرسم البياني... قد يستغرق هذا بضع ثوانٍ أثناء تحليل بيانات المخزون الخاصة بك.'
    },
  'Loading stock health...': {
    en: 'Loading stock health...',
    fr: "Chargement de l'état du stock...",
    ar: 'جارٍ تحميل صحة المخزون...'
  },
  'Stock In Value': {
    en: 'Stock In Value',
    fr: 'Valeur du stock entrant',
    ar: 'قيمة المخزون الداخل'
  },
  'Stock Out Value': {
    en: 'Stock Out Value',
    fr: 'Valeur du stock sortant',
    ar: 'قيمة المخزون الخارج'
  },
  'Net Value': {
    en: 'Net Value',
    fr: 'Valeur nette',
    ar: 'القيمة الصافية'
  },
  'Stock in': {
    en: 'Stock in',
    fr: 'Stock entrant',
    ar: 'المخزون الداخل'
  },
  'Stock out': {
    en: 'Stock out',
    fr: 'Stock sortant',
    ar: 'المخزون الخارج'
  },
  'Stock in value': {
    en: 'Stock in value',
    fr: 'Valeur du stock entrant',
    ar: 'قيمة المخزون الداخل'
  },
  'Stock out value': {
    en: 'Stock out value',
    fr: 'Valeur du stock sortant',
    ar: 'قيمة المخزون الخارج'
  },
  'No value data yet': {
    en: 'No value data yet',
    fr: 'Aucune donnée de valeur pour le moment',
    ar: 'لا توجد بيانات قيمة بعد'
  },
  'Stock in and stock out values will appear when inventory activity exists.': {
    en: 'Stock in and stock out values will appear when inventory activity exists.',
    fr: "Les valeurs de stock entrant et sortant apparaîtront lorsqu'il y aura de l'activité d'inventaire.",
    ar: 'ستظهر قيم المخزون الداخل والخارج عند وجود نشاط في المخزون.'
  },
  'Healthy, low-stock, and out-of-stock items.': {
    en: 'Healthy, low-stock, and out-of-stock items.',
    fr: 'Articles sains, en stock faible et en rupture de stock.',
    ar: 'العناصر السليمة والمنخفضة والمنتهية من المخزون.'
  },
  'Low stock means quantity is below minimum level and alert is enabled.': {
    en: 'Low stock means quantity is below minimum level and alert is enabled.',
    fr: "Un stock faible signifie que la quantité est inférieure au niveau minimum et que l'alerte est activée.",
    ar: 'المخزون المنخفض يعني أن الكمية أقل من الحد الأدنى والتنبيه مفعّل.'
  },
  'Items that need attention before they run out.': {
    en: 'Items that need attention before they run out.',
    fr: "Articles qui nécessitent une attention avant d'être épuisés.",
    ar: 'عناصر تحتاج إلى اهتمام قبل نفادها.'
  },
  'Unnamed item': {
    en: 'Unnamed item',
    fr: 'Article sans nom',
    ar: 'عنصر بدون اسم'
  },
  'In stock': {
    en: 'In stock',
    fr: 'En stock',
    ar: 'متوفر في المخزون'
  },
  'Low stock': {
    en: 'Low stock',
    fr: 'Stock faible',
    ar: 'مخزون منخفض'
  },
  'No low stock items': {
    en: 'No low stock items',
    fr: 'Aucun article en stock faible',
    ar: 'لا توجد عناصر منخفضة المخزون'
  },
  'Everything looks good for now.': {
    en: 'Everything looks good for now.',
    fr: 'Tout semble correct pour le moment.',
    ar: 'كل شيء يبدو جيدًا في الوقت الحالي.'
  },
  'View all low stock items': {
    en: 'View all low stock items',
    fr: 'Voir tous les articles en stock faible',
    ar: 'عرض كل العناصر منخفضة المخزون'
  },
  'Recent Activities': {
    en: 'Recent Activities',
    fr: 'Activités récentes',
    ar: 'الأنشطة الحديثة'
  },
  'Recent moves, added items, and purchase order activity.': {
    en: 'Recent moves, added items, and purchase order activity.',
    fr: 'Mouvements récents, articles ajoutés et activité des bons de commande.',
    ar: 'النقلات الحديثة والعناصر المضافة ونشاط أوامر الشراء.'
  },
  'No recent activity yet': {
    en: 'No recent activity yet',
    fr: 'Aucune activité récente pour le moment',
    ar: 'لا توجد أنشطة حديثة بعد'
  },
  'Activity will appear here when items move, items are added, or purchase orders are created.':
    {
      en: 'Activity will appear here when items move, items are added, or purchase orders are created.',
      fr: 'L’activité apparaîtra ici lorsque des articles seront déplacés, ajoutés ou lorsque des bons de commande seront créés.',
      ar: 'ستظهر الأنشطة هنا عند نقل العناصر أو إضافتها أو إنشاء أوامر شراء.'
    },
  'Fast shortcuts for common operations.': {
    en: 'Fast shortcuts for common operations.',
    fr: 'Raccourcis rapides pour les opérations courantes.',
    ar: 'اختصارات سريعة للعمليات الشائعة.'
  },
  'Operational Snapshot': {
    en: 'Operational Snapshot',
    fr: 'Aperçu opérationnel',
    ar: 'لمحة تشغيلية'
  },
  'Quick status of your inventory workspace.': {
    en: 'Quick status of your inventory workspace.',
    fr: 'État rapide de votre espace de travail d’inventaire.',
    ar: 'حالة سريعة لمساحة عمل المخزون الخاصة بك.'
  },
  'Stock health': {
    en: 'Stock health',
    fr: 'Santé du stock',
    ar: 'صحة المخزون'
  },
  Structure: {
    en: 'Structure',
    fr: 'Structure',
    ar: 'الهيكل'
  },
  'Inventory value': {
    en: 'Inventory value',
    fr: "Valeur de l'inventaire",
    ar: 'قيمة المخزون'
  },
  categories: {
    en: 'categories',
    fr: 'catégories',
    ar: 'فئات'
  },
  folders: {
    en: 'folders',
    fr: 'dossiers',
    ar: 'مجلدات'
  },
  'item needs attention': {
    en: 'item needs attention',
    fr: 'article nécessite une attention',
    ar: 'عنصر يحتاج إلى اهتمام'
  },
  'items need attention': {
    en: 'items need attention',
    fr: 'articles nécessitent une attention',
    ar: 'عناصر تحتاج إلى اهتمام'
  },
  'An item with the same': {
    en: 'An item with the same',
    fr: 'Un article avec le même',
    ar: 'يوجد عنصر بنفس'
  },
  information: {
    en: 'information',
    fr: 'information',
    ar: 'المعلومات'
  },
  'already exists.': {
    en: 'already exists.',
    fr: 'existe déjà.',
    ar: 'موجود بالفعل.'
  },
  'Do you want to update it instead?': {
    en: 'Do you want to update it instead?',
    fr: 'Voulez-vous le mettre à jour à la place ?',
    ar: 'هل تريد تحديثه بدلاً من ذلك؟'
  },
  'Item created': {
    en: 'Item created',
    fr: 'Article créé',
    ar: 'تم إنشاء العنصر'
  },
  'Item updated': {
    en: 'Item updated',
    fr: 'Article mis à jour',
    ar: 'تم تحديث العنصر'
  },
  'Item deleted': {
    en: 'Item deleted',
    fr: 'Article supprimé',
    ar: 'تم حذف العنصر'
  },
  'Quantity adjusted': {
    en: 'Quantity adjusted',
    fr: 'Quantité ajustée',
    ar: 'تم تعديل الكمية'
  },
  'Item moved': {
    en: 'Item moved',
    fr: 'Article déplacé',
    ar: 'تم نقل العنصر'
  },
  'Items moved': {
    en: 'Items moved',
    fr: 'Articles déplacés',
    ar: 'تم نقل العناصر'
  },
  'Categories updated': {
    en: 'Categories updated',
    fr: 'Catégories mises à jour',
    ar: 'تم تحديث الفئات'
  },
  'Folder created': {
    en: 'Folder created',
    fr: 'Dossier créé',
    ar: 'تم إنشاء المجلد'
  },
  'Folder updated': {
    en: 'Folder updated',
    fr: 'Dossier mis à jour',
    ar: 'تم تحديث المجلد'
  },
  'Folder deleted': {
    en: 'Folder deleted',
    fr: 'Dossier supprimé',
    ar: 'تم حذف المجلد'
  },
  'Folder moved': {
    en: 'Folder moved',
    fr: 'Dossier déplacé',
    ar: 'تم نقل المجلد'
  },
  'Category created': {
    en: 'Category created',
    fr: 'Catégorie créée',
    ar: 'تم إنشاء الفئة'
  },
  'Category updated': {
    en: 'Category updated',
    fr: 'Catégorie mise à jour',
    ar: 'تم تحديث الفئة'
  },
  'Category deleted': {
    en: 'Category deleted',
    fr: 'Catégorie supprimée',
    ar: 'تم حذف الفئة'
  },
  'Category moved': {
    en: 'Category moved',
    fr: 'Catégorie déplacée',
    ar: 'تم نقل الفئة'
  },
  'Folder:': {
    en: 'Folder:',
    fr: 'Dossier :',
    ar: 'المجلد:'
  },
  'Category:': {
    en: 'Category:',
    fr: 'Catégorie :',
    ar: 'الفئة:'
  },
  'Delta:': {
    en: 'Delta:',
    fr: 'Écart :',
    ar: 'التغيير:'
  },
  'Done by': {
    en: 'Done by',
    fr: 'Effectué par',
    ar: 'تم بواسطة'
  },
  'Activity recorded': {
    en: 'Activity recorded',
    fr: 'Activité enregistrée',
    ar: 'تم تسجيل النشاط'
  },
  Activity: {
    en: 'Activity',
    fr: 'Activité',
    ar: 'النشاط'
  },
  'Item created successfully': {
    en: 'Item created successfully',
    fr: 'Article créé avec succès',
    ar: 'تم إنشاء العنصر بنجاح'
  },
  'Item updated successfully': {
    en: 'Item updated successfully',
    fr: 'Article mis à jour avec succès',
    ar: 'تم تحديث العنصر بنجاح'
  },
  'Category created successfully': {
    en: 'Category created successfully',
    fr: 'Catégorie créée avec succès',
    ar: 'تم إنشاء الفئة بنجاح'
  },
  'Folder created successfully': {
    en: 'Folder created successfully',
    fr: 'Dossier créé avec succès',
    ar: 'تم إنشاء المجلد بنجاح'
  },
  'Item created, but image upload failed': {
    en: 'Item created, but image upload failed',
    fr: "Article créé, mais le téléversement de l'image a échoué",
    ar: 'تم إنشاء العنصر، لكن فشل تحميل الصورة'
  },
  'Within limit': {
    en: 'Within limit',
    fr: 'Dans la limite',
    ar: 'ضمن الحد'
  },
  'Over limit': {
    en: 'Over limit',
    fr: 'Au-dessus de la limite',
    ar: 'فوق الحد'
  },
  'Recent Actions': {
    en: 'Recent Actions',
    fr: 'Actions récentes',
    ar: 'الإجراءات الأخيرة'
  },
  'Manage, move, and update your inventory items.': {
    en: 'Manage, move, and update your inventory items.',
    fr: 'Gérez, déplacez et mettez à jour vos articles en stock.',
    ar: 'قم بإدارة عناصر المخزون ونقلها وتحديثها.'
  },
  'Organize stock by location, workflow, customer, or process.': {
    en: 'Organize stock by location, workflow, customer, or process.',
    fr: 'Organisez le stock par emplacement, flux de travail, client ou processus.',
    ar: 'نظم المخزون حسب الموقع أو سير العمل أو العميل أو العملية.'
  },
  'Price: Low to High': {
    en: 'Price: Low to High',
    fr: 'Prix : du plus bas au plus haut',
    ar: 'السعر: من الأقل إلى الأعلى'
  },
  'Price: High to Low': {
    en: 'Price: High to Low',
    fr: 'Prix : du plus haut au plus bas',
    ar: 'السعر: من الأعلى إلى الأقل'
  },
  'By category': {
    en: 'By category',
    fr: 'Par catégorie',
    ar: 'حسب الفئة'
  },
  'Newest Arrivals': {
    en: 'Newest Arrivals',
    fr: 'Arrivages les plus récents',
    ar: 'أحدث العناصر'
  },
  'Oldest Arrival': {
    en: 'Oldest Arrival',
    fr: 'Arrivage le plus ancien',
    ar: 'أقدم عنصر'
  },
  'An item with the same {reason} already exists.': {
    en: 'An item with the same {reason} already exists.',
    fr: 'Un article avec le même {reason} existe déjà.',
    ar: 'يوجد عنصر بنفس {reason} بالفعل.'
  },
  'Barcode:': {
    en: 'Barcode:',
    fr: 'Code-barres :',
    ar: 'الرمز الشريطي:'
  },
  'Added {n} to {item}': {
    en: 'Added {n} to {item}',
    fr: '{n} ajouté à {item}',
    ar: 'تمت إضافة {n} إلى {item}'
  },
  'Subtracted {n} from {item}': {
    en: 'Subtracted {n} from {item}',
    fr: '{n} retiré de {item}',
    ar: 'تم طرح {n} من {item}'
  },
  '{n}s ago': {
    en: '{n}s ago',
    fr: 'il y a {n} s',
    ar: 'منذ {n} ث'
  },
  '{n}m ago': {
    en: '{n}m ago',
    fr: 'il y a {n} min',
    ar: 'منذ {n} د'
  },
  '{n}h ago': {
    en: '{n}h ago',
    fr: 'il y a {n} h',
    ar: 'منذ {n} س'
  },
  'Failed to generate barcodes PDF': {
    en: 'Failed to generate barcodes PDF',
    fr: 'Impossible de générer le PDF des codes-barres',
    ar: 'فشل إنشاء ملف PDF للباركود'
  },
  'Barcode generated': {
    en: 'Barcode generated',
    fr: 'Code-barres généré',
    ar: 'تم إنشاء الباركود'
  },
  'Failed to generate barcode': {
    en: 'Failed to generate barcode',
    fr: 'Impossible de générer le code-barres',
    ar: 'فشل إنشاء الباركود'
  },
  'Please choose either file upload OR photo URL, not both': {
    en: 'Please choose either file upload OR photo URL, not both',
    fr: 'Veuillez choisir soit un fichier à téléverser, soit une URL de photo, pas les deux',
    ar: 'يرجى اختيار رفع ملف أو رابط صورة، وليس الاثنين معًا'
  },
  'Please wait for authentication to complete before creating items': {
    en: 'Please wait for authentication to complete before creating items',
    fr: "Veuillez attendre la fin de l'authentification avant de créer des articles",
    ar: 'يرجى انتظار اكتمال المصادقة قبل إنشاء العناصر'
  },
  'Item updated with new quantity and prices': {
    en: 'Item updated with new quantity and prices',
    fr: 'Article mis à jour avec la nouvelle quantité et les nouveaux prix',
    ar: 'تم تحديث العنصر بالكمية والأسعار الجديدة'
  },
  'Failed to merge item': {
    en: 'Failed to merge item',
    fr: "Impossible de fusionner l'article",
    ar: 'فشل دمج العنصر'
  },
  'Failed to fetch items:': {
    en: 'Failed to fetch items:',
    fr: 'Impossible de récupérer les articles :',
    ar: 'فشل جلب العناصر:'
  },
  'Failed to fetch categories:': {
    en: 'Failed to fetch categories:',
    fr: 'Impossible de récupérer les catégories :',
    ar: 'فشل جلب الفئات:'
  },
  'Failed to fetch folders:': {
    en: 'Failed to fetch folders:',
    fr: 'Impossible de récupérer les dossiers :',
    ar: 'فشل جلب المجلدات:'
  },
  'Product information filled automatically!': {
    en: 'Product information filled automatically!',
    fr: 'Informations produit remplies automatiquement !',
    ar: 'تمت تعبئة معلومات المنتج تلقائيًا!'
  },
  'Activity events will appear here once actions are recorded.': {
    en: 'Activity events will appear here once actions are recorded.',
    fr: "Les événements d'activité apparaîtront ici une fois les actions enregistrées.",
    ar: 'ستظهر أحداث النشاط هنا بعد تسجيل الإجراءات.'
  },
  'Add Quantity': {
    en: 'Add Quantity',
    fr: 'Ajouter une quantité',
    ar: 'إضافة كمية'
  },
  'Add a new user to your organization and assign their role.': {
    en: 'Add a new user to your organization and assign their role.',
    fr: 'Ajoutez un nouvel utilisateur à votre organisation et attribuez son rôle.',
    ar: 'أضف مستخدمًا جديدًا إلى مؤسستك وعيّن دوره.'
  },
  'Add any additional notes about this item...': {
    en: 'Add any additional notes about this item...',
    fr: 'Ajoutez des notes supplémentaires sur cet article...',
    ar: 'أضف أي ملاحظات إضافية حول هذا العنصر...'
  },
  'Are you sure you want to delete this category?': {
    en: 'Are you sure you want to delete this category?',
    fr: 'Voulez-vous vraiment supprimer cette catégorie ?',
    ar: 'هل أنت متأكد من حذف هذه الفئة؟'
  },
  'At least one role required': {
    en: 'At least one role required',
    fr: 'Au moins un rôle est requis',
    ar: 'مطلوب دور واحد على الأقل'
  },
  'Browse child categories inside this category': {
    en: 'Browse child categories inside this category',
    fr: 'Parcourez les sous-catégories de cette catégorie',
    ar: 'تصفح الفئات الفرعية داخل هذه الفئة'
  },
  'Browse inventory items grouped by tags': {
    en: 'Browse inventory items grouped by tags',
    fr: 'Parcourez les articles regroupés par étiquettes',
    ar: 'تصفح عناصر المخزون المجمعة حسب الوسوم'
  },
  Buying: {
    en: 'Buying',
    fr: 'Achat',
    ar: 'الشراء'
  },
  'Complete both label and value.': {
    en: 'Complete both label and value.',
    fr: 'Renseignez à la fois le libellé et la valeur.',
    ar: 'أكمل التسمية والقيمة معًا.'
  },
  'Confirm Deletion': {
    en: 'Confirm Deletion',
    fr: 'Confirmer la suppression',
    ar: 'تأكيد الحذف'
  },
  'Create users, manage roles, and control organization access.': {
    en: 'Create users, manage roles, and control organization access.',
    fr: "Créez des utilisateurs, gérez les rôles et contrôlez l'accès à l'organisation.",
    ar: 'أنشئ مستخدمين وأدر الأدوار وتحكم في الوصول إلى المؤسسة.'
  },
  'Created users will appear here.': {
    en: 'Created users will appear here.',
    fr: 'Les utilisateurs créés apparaîtront ici.',
    ar: 'سيظهر المستخدمون الذين تم إنشاؤهم هنا.'
  },
  'Current user': {
    en: 'Current user',
    fr: 'Utilisateur actuel',
    ar: 'المستخدم الحالي'
  },
  'Delete Permanently': {
    en: 'Delete Permanently',
    fr: 'Supprimer définitivement',
    ar: 'حذف نهائيًا'
  },
  'Deleting this user will permanently remove their access and cannot be undone.':
    {
      en: 'Deleting this user will permanently remove their access and cannot be undone.',
      fr: 'La suppression de cet utilisateur retirera définitivement son accès et ne pourra pas être annulée.',
      ar: 'سيؤدي حذف هذا المستخدم إلى إزالة وصوله نهائيًا ولا يمكن التراجع عن ذلك.'
    },
  Events: {
    en: 'Events',
    fr: 'Événements',
    ar: 'الأحداث'
  },
  'Existing Users': {
    en: 'Existing Users',
    fr: 'Utilisateurs existants',
    ar: 'المستخدمون الحاليون'
  },
  'Failed to delete': {
    en: 'Failed to delete',
    fr: 'Échec de la suppression',
    ar: 'فشل الحذف'
  },
  'Failed to delete user': {
    en: 'Failed to delete user',
    fr: "Impossible de supprimer l'utilisateur",
    ar: 'فشل حذف المستخدم'
  },
  'Failed to update roles': {
    en: 'Failed to update roles',
    fr: 'Impossible de mettre à jour les rôles',
    ar: 'فشل تحديث الأدوار'
  },
  Filters: {
    en: 'Filters',
    fr: 'Filtres',
    ar: 'الفلاتر'
  },
  'Item Details': {
    en: 'Item Details',
    fr: "Détails de l'article",
    ar: 'تفاصيل العنصر'
  },
  'Items affected by this transaction': {
    en: 'Items affected by this transaction',
    fr: 'Articles concernés par cette transaction',
    ar: 'العناصر المتأثرة بهذه العملية'
  },
  'Loading image': {
    en: 'Loading image',
    fr: "Chargement de l'image",
    ar: 'جار تحميل الصورة'
  },
  'Main Information': {
    en: 'Main Information',
    fr: 'Informations principales',
    ar: 'المعلومات الأساسية'
  },
  'Manage items linked to this category': {
    en: 'Manage items linked to this category',
    fr: 'Gérez les articles liés à cette catégorie',
    ar: 'إدارة العناصر المرتبطة بهذه الفئة'
  },
  'Manage user roles and remove users from this organization.': {
    en: 'Manage user roles and remove users from this organization.',
    fr: 'Gérez les rôles des utilisateurs et retirez des utilisateurs de cette organisation.',
    ar: 'أدر أدوار المستخدمين وأزل المستخدمين من هذه المؤسسة.'
  },
  Metadata: {
    en: 'Metadata',
    fr: 'Métadonnées',
    ar: 'البيانات الوصفية'
  },
  'Negative Delta': {
    en: 'Negative Delta',
    fr: 'Variation négative',
    ar: 'فرق سلبي'
  },
  'No Items Found': {
    en: 'No Items Found',
    fr: 'Aucun article trouvé',
    ar: 'لم يتم العثور على عناصر'
  },
  'No Transactions Found': {
    en: 'No Transactions Found',
    fr: 'Aucune transaction trouvée',
    ar: 'لم يتم العثور على عمليات'
  },
  'No custom fields defined': {
    en: 'No custom fields defined',
    fr: 'Aucun champ personnalisé défini',
    ar: 'لا توجد حقول مخصصة معرفة'
  },
  'No custom fields yet.': {
    en: 'No custom fields yet.',
    fr: 'Aucun champ personnalisé pour le moment.',
    ar: 'لا توجد حقول مخصصة بعد.'
  },
  'No folders found': {
    en: 'No folders found',
    fr: 'Aucun dossier trouvé',
    ar: 'لم يتم العثور على مجلدات'
  },
  'No image': {
    en: 'No image',
    fr: 'Aucune image',
    ar: 'لا توجد صورة'
  },
  'No items found': {
    en: 'No items found',
    fr: 'Aucun article trouvé',
    ar: 'لم يتم العثور على عناصر'
  },
  'No items found in this folder.': {
    en: 'No items found in this folder.',
    fr: 'Aucun article trouvé dans ce dossier.',
    ar: 'لم يتم العثور على عناصر في هذا المجلد.'
  },
  'No items in this transaction': {
    en: 'No items in this transaction',
    fr: 'Aucun article dans cette transaction',
    ar: 'لا توجد عناصر في هذه العملية'
  },
  'No role changes detected': {
    en: 'No role changes detected',
    fr: 'Aucun changement de rôle détecté',
    ar: 'لم يتم اكتشاف تغييرات في الأدوار'
  },
  'No subfolders found': {
    en: 'No subfolders found',
    fr: 'Aucun sous-dossier trouvé',
    ar: 'لم يتم العثور على مجلدات فرعية'
  },
  'No tags': {
    en: 'No tags',
    fr: 'Aucune étiquette',
    ar: 'لا توجد وسوم'
  },
  'No tags found': {
    en: 'No tags found',
    fr: 'Aucune étiquette trouvée',
    ar: 'لم يتم العثور على وسوم'
  },
  'No tags yet': {
    en: 'No tags yet',
    fr: 'Aucune étiquette pour le moment',
    ar: 'لا توجد وسوم بعد'
  },
  'No transactions found in this folder.': {
    en: 'No transactions found in this folder.',
    fr: 'Aucune transaction trouvée dans ce dossier.',
    ar: 'لم يتم العثور على عمليات في هذا المجلد.'
  },
  'No users found': {
    en: 'No users found',
    fr: 'Aucun utilisateur trouvé',
    ar: 'لم يتم العثور على مستخدمين'
  },
  Organization: {
    en: 'Organization',
    fr: 'Organisation',
    ar: 'المؤسسة'
  },
  'Organization user': {
    en: 'Organization user',
    fr: "Utilisateur de l'organisation",
    ar: 'مستخدم المؤسسة'
  },
  'Positive Delta': {
    en: 'Positive Delta',
    fr: 'Variation positive',
    ar: 'فرق إيجابي'
  },
  'Preview before saving': {
    en: 'Preview before saving',
    fr: "Aperçu avant l'enregistrement",
    ar: 'معاينة قبل الحفظ'
  },
  Roles: {
    en: 'Roles',
    fr: 'Rôles',
    ar: 'الأدوار'
  },
  'Roles updated': {
    en: 'Roles updated',
    fr: 'Rôles mis à jour',
    ar: 'تم تحديث الأدوار'
  },
  'Root Folders': {
    en: 'Root Folders',
    fr: 'Dossiers racine',
    ar: 'المجلدات الجذرية'
  },
  'Search Categories': {
    en: 'Search Categories',
    fr: 'Rechercher des catégories',
    ar: 'البحث في الفئات'
  },
  'Search Folders': {
    en: 'Search Folders',
    fr: 'Rechercher des dossiers',
    ar: 'البحث في المجلدات'
  },
  'Search and filter activity events by user, item, folder, category, date, and action.':
    {
      en: 'Search and filter activity events by user, item, folder, category, date, and action.',
      fr: "Recherchez et filtrez les événements d'activité par utilisateur, article, dossier, catégorie, date et action.",
      ar: 'ابحث وصفّ أحداث النشاط حسب المستخدم أو العنصر أو المجلد أو الفئة أو التاريخ أو الإجراء.'
    },
  Select: {
    en: 'Select',
    fr: 'Sélectionner',
    ar: 'تحديد'
  },
  Selling: {
    en: 'Selling',
    fr: 'Vente',
    ar: 'البيع'
  },
  'Showing events matching your filters.': {
    en: 'Showing events matching your filters.',
    fr: 'Affichage des événements correspondant à vos filtres.',
    ar: 'عرض الأحداث المطابقة للفلاتر.'
  },
  'Showing the latest inventory activity events.': {
    en: 'Showing the latest inventory activity events.',
    fr: "Affichage des derniers événements d'activité de l'inventaire.",
    ar: 'عرض أحدث أحداث نشاط المخزون.'
  },
  Sort: {
    en: 'Sort',
    fr: 'Trier',
    ar: 'فرز'
  },
  'Subtract Quantity': {
    en: 'Subtract Quantity',
    fr: 'Soustraire une quantité',
    ar: 'طرح كمية'
  },
  'Tags will appear here once items have tags.': {
    en: 'Tags will appear here once items have tags.',
    fr: 'Les étiquettes apparaîtront ici lorsque des articles en auront.',
    ar: 'ستظهر الوسوم هنا عندما تحتوي العناصر على وسوم.'
  },
  'This action is irreversible!': {
    en: 'This action is irreversible!',
    fr: 'Cette action est irréversible !',
    ar: 'هذا الإجراء لا يمكن التراجع عنه!'
  },
  'Total Folders': {
    en: 'Total Folders',
    fr: 'Total des dossiers',
    ar: 'إجمالي المجلدات'
  },
  'Transaction Details': {
    en: 'Transaction Details',
    fr: 'Détails de la transaction',
    ar: 'تفاصيل العملية'
  },
  'Try another search term': {
    en: 'Try another search term',
    fr: 'Essayez un autre terme de recherche',
    ar: 'جرّب مصطلح بحث آخر'
  },
  'Try clearing filters or changing your search criteria.': {
    en: 'Try clearing filters or changing your search criteria.',
    fr: 'Essayez de réinitialiser les filtres ou de modifier vos critères de recherche.',
    ar: 'جرّب مسح الفلاتر أو تغيير معايير البحث.'
  },
  Units: {
    en: 'Units',
    fr: 'Unités',
    ar: 'الوحدات'
  },
  'Update Quantity': {
    en: 'Update Quantity',
    fr: 'Mettre à jour la quantité',
    ar: 'تحديث الكمية'
  },
  'User deleted': {
    en: 'User deleted',
    fr: 'Utilisateur supprimé',
    ar: 'تم حذف المستخدم'
  },
  'View Details': {
    en: 'View Details',
    fr: 'Voir les détails',
    ar: 'عرض التفاصيل'
  },
  Visible: {
    en: 'Visible',
    fr: 'Visible',
    ar: 'مرئي'
  },
  'Visible Items': {
    en: 'Visible Items',
    fr: 'Articles visibles',
    ar: 'العناصر المرئية'
  },
  'Visible Tags': {
    en: 'Visible Tags',
    fr: 'Étiquettes visibles',
    ar: 'الوسوم المرئية'
  },
  'You cannot delete yourself': {
    en: 'You cannot delete yourself',
    fr: 'Vous ne pouvez pas vous supprimer vous-même',
    ar: 'لا يمكنك حذف نفسك'
  },
  'You cannot undo this. Are you sure you want to proceed?': {
    en: 'You cannot undo this. Are you sure you want to proceed?',
    fr: 'Vous ne pouvez pas annuler cette action. Voulez-vous continuer ?',
    ar: 'لا يمكنك التراجع عن هذا. هل أنت متأكد من المتابعة؟'
  },
  'You requested {n} barcodes': {
    en: 'You requested {n} barcodes',
    fr: 'Vous avez demandé {n} codes-barres',
    ar: 'لقد طلبت {n} باركود'
  },
  'custom field(s) defined': {
    en: 'custom field(s) defined',
    fr: 'champ(s) personnalisé(s) défini(s)',
    ar: 'حقول مخصصة معرفة'
  },
  'in stock': {
    en: 'in stock',
    fr: 'en stock',
    ar: 'في المخزون'
  },
  returned: {
    en: 'returned',
    fr: 'retourné',
    ar: 'مُرجع'
  },
  transferred: {
    en: 'transferred',
    fr: 'transféré',
    ar: 'منقول'
  },
  'Maximum number of users (5) reached for this organization.': {
    en: 'Maximum number of users (5) reached for this organization.',
    fr: "Le nombre maximal d'utilisateurs (5) est atteint pour cette organisation.",
    ar: 'تم الوصول إلى الحد الأقصى لعدد المستخدمين (5) لهذه المؤسسة.'
  },
  'Password is required': {
    en: 'Password is required',
    fr: 'Le mot de passe est requis',
    ar: 'كلمة المرور مطلوبة'
  },
  'Password must be at least {n} characters': {
    en: 'Password must be at least {n} characters',
    fr: 'Le mot de passe doit contenir au moins {n} caractères',
    ar: 'يجب أن تتكون كلمة المرور من {n} أحرف على الأقل'
  },
  'Password must include at least one lowercase letter': {
    en: 'Password must include at least one lowercase letter',
    fr: 'Le mot de passe doit contenir au moins une lettre minuscule',
    ar: 'يجب أن تحتوي كلمة المرور على حرف صغير واحد على الأقل'
  },
  'Password must include at least one uppercase letter': {
    en: 'Password must include at least one uppercase letter',
    fr: 'Le mot de passe doit contenir au moins une lettre majuscule',
    ar: 'يجب أن تحتوي كلمة المرور على حرف كبير واحد على الأقل'
  },
  'Password must include at least one number': {
    en: 'Password must include at least one number',
    fr: 'Le mot de passe doit contenir au moins un chiffre',
    ar: 'يجب أن تحتوي كلمة المرور على رقم واحد على الأقل'
  },
  'Password must include one special character: {chars}': {
    en: 'Password must include one special character: {chars}',
    fr: 'Le mot de passe doit contenir un caractère spécial : {chars}',
    ar: 'يجب أن تحتوي كلمة المرور على رمز خاص واحد: {chars}'
  },
  'At least 8 characters': {
    en: 'At least 8 characters',
    fr: 'Au moins 8 caractères',
    ar: '8 أحرف على الأقل'
  },
  'At least one lowercase letter': {
    en: 'At least one lowercase letter',
    fr: 'Au moins une lettre minuscule',
    ar: 'حرف صغير واحد على الأقل'
  },
  'At least one uppercase letter': {
    en: 'At least one uppercase letter',
    fr: 'Au moins une lettre majuscule',
    ar: 'حرف كبير واحد على الأقل'
  },
  'At least one number': {
    en: 'At least one number',
    fr: 'Au moins un chiffre',
    ar: 'رقم واحد على الأقل'
  },
  'At least one special character: {chars}': {
    en: 'At least one special character: {chars}',
    fr: 'Au moins un caractère spécial : {chars}',
    ar: 'رمز خاص واحد على الأقل: {chars}'
  },
  'User created': {
    en: 'User created',
    fr: 'Utilisateur créé',
    ar: 'تم إنشاء المستخدم'
  },
  'Failed to create user': {
    en: 'Failed to create user',
    fr: "Impossible de créer l'utilisateur",
    ar: 'فشل إنشاء المستخدم'
  },
  'Request failed': {
    en: 'Request failed',
    fr: 'Échec de la requête',
    ar: 'فشل الطلب'
  },
  'Failed to load users': {
    en: 'Failed to load users',
    fr: 'Impossible de charger les utilisateurs',
    ar: 'فشل تحميل المستخدمين'
  },
  'Missing organization id (owner not initialized).': {
    en: 'Missing organization id (owner not initialized).',
    fr: "Identifiant d'organisation manquant (propriétaire non initialisé).",
    ar: 'معرف المؤسسة مفقود (لم تتم تهيئة المالك).'
  },
  'Try changing your search or filters.': {
    en: 'Try changing your search or filters.',
    fr: 'Essayez de modifier votre recherche ou vos filtres.',
    ar: 'جرّب تغيير البحث أو الفلاتر.'
  },
  'Adjust quantity': {
    en: 'Adjust quantity',
    fr: 'Ajuster la quantité',
    ar: 'تعديل الكمية'
  },
  'Edit item': {
    en: 'Edit item',
    fr: "Modifier l'article",
    ar: 'تعديل العنصر'
  },
  'Print barcode': {
    en: 'Print barcode',
    fr: 'Imprimer le code-barres',
    ar: 'طباعة الباركود'
  },
  'Unnamed folder': {
    en: 'Unnamed folder',
    fr: 'Dossier sans nom',
    ar: 'مجلد بدون اسم'
  },
  'Unnamed category': {
    en: 'Unnamed category',
    fr: 'Catégorie sans nom',
    ar: 'فئة بدون اسم'
  },
  'Low Stock Soon': {
    en: 'Low Stock Soon',
    fr: 'Stock bientôt faible',
    ar: 'المخزون سينخفض قريبًا'
  },
  Recent: {
    en: 'Recent',
    fr: 'Récent',
    ar: 'الأحدث'
  },
  'Quantity is required': {
    en: 'Quantity is required',
    fr: 'La quantité est requise',
    ar: 'الكمية مطلوبة'
  },
  'Quantity must be greater than zero': {
    en: 'Quantity must be greater than zero',
    fr: 'La quantité doit être supérieure à zéro',
    ar: 'يجب أن تكون الكمية أكبر من صفر'
  },
  'Quantity exceeds available stock': {
    en: 'Quantity exceeds available stock',
    fr: 'La quantité dépasse le stock disponible',
    ar: 'الكمية تتجاوز المخزون المتاح'
  },
  'Cannot subtract more than available quantity ({n})': {
    en: 'Cannot subtract more than available quantity ({n})',
    fr: 'Impossible de soustraire plus que la quantité disponible ({n})',
    ar: 'لا يمكن طرح أكثر من الكمية المتاحة ({n})'
  },
  Required: {
    en: 'Required',
    fr: 'Obligatoire',
    ar: 'مطلوب'
  },
  'Invalid email': {
    en: 'Invalid email',
    fr: 'Adresse e-mail invalide',
    ar: 'بريد إلكتروني غير صالح'
  },
  'Sub Cats': {
    en: 'Sub Cats',
    fr: 'Sous-catégories',
    ar: 'فئات فرعية'
  },
  'All Cats': {
    en: 'All Cats',
    fr: 'Toutes les catégories',
    ar: 'كل الفئات'
  },
  'Unknown folder': {
    en: 'Unknown folder',
    fr: 'Dossier inconnu',
    ar: 'مجلد غير معروف'
  },
  Transfer: {
    en: 'Transfer',
    fr: 'Transfert',
    ar: 'نقل'
  },
  'Something went wrong. Please try again.': {
    en: 'Something went wrong. Please try again.',
    fr: "Une erreur s'est produite. Veuillez réessayer.",
    ar: 'حدث خطأ ما. يرجى المحاولة مرة أخرى.'
  }
}

export default DIALECT
